export var tokensData = {
    'part': 0,
    'eventsNumber': 1269,
    'start': 1452006000000,
    'complete': 1508857200000,
    'listOfEvent': [
        {
            'caseId': 'I16-075800',
            'eventId': '10',
            'eventName': 'D|A',
            'source': 'D',
            'target': 'A',
            'start': 1452006000000,
            'complete': 1452610800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-076500',
            'eventId': '8',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1452438000000,
            'complete': 1455721200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-076600',
            'eventId': '11',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1452438000000,
            'complete': 1464706800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-076800',
            'eventId': '9',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1452610800000,
            'complete': 1455116400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-075800',
            'eventId': '10',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1452610800000,
            'complete': 1453042800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077100',
            'eventId': '8',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1452697200000,
            'complete': 1455116400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-076900',
            'eventId': '10',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1452783600000,
            'complete': 1453906800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077000',
            'eventId': '9',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1452783600000,
            'complete': 1454511600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-076600',
            'eventId': '11',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1453042800000,
            'complete': 1453734000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-075800',
            'eventId': '10',
            'eventName': 'J|M',
            'source': 'J',
            'target': 'M',
            'start': 1453042800000,
            'complete': 1453215600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077300',
            'eventId': '10',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1453042800000,
            'complete': 1453215600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077200',
            'eventId': '10',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1453042800000,
            'complete': 1453215600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-075900',
            'eventId': '10',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1453042800000,
            'complete': 1455634800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077500',
            'eventId': '11',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1453042800000,
            'complete': 1500476400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-075800',
            'eventId': '10',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1453215600000,
            'complete': 1461250800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077300',
            'eventId': '10',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1453215600000,
            'complete': 1453993200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077200',
            'eventId': '10',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1453215600000,
            'complete': 1456066800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077400',
            'eventId': '10',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1453215600000,
            'complete': 1455116400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077600',
            'eventId': '10',
            'eventName': 'YY|WW',
            'source': 'YY',
            'target': 'WW',
            'start': 1453734000000,
            'complete': 1455462000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-076600',
            'eventId': '11',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1453734000000,
            'complete': 1456153200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-076400',
            'eventId': '8',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1453734000000,
            'complete': 1454598000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078100',
            'eventId': '9',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1453734000000,
            'complete': 1455548400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-076700',
            'eventId': '8',
            'eventName': 'YY|WW',
            'source': 'YY',
            'target': 'WW',
            'start': 1453734000000,
            'complete': 1455634800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-076900',
            'eventId': '10',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1453906800000,
            'complete': 1456066800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077500',
            'eventId': '11',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1453906800000,
            'complete': 1456066800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077300',
            'eventId': '10',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1453993200000,
            'complete': 1456066800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078700',
            'eventId': '10',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1454425200000,
            'complete': 1455116400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078000',
            'eventId': '10',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1454511600000,
            'complete': 1455634800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078400',
            'eventId': '10',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1454511600000,
            'complete': 1456412400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-079500',
            'eventId': '6',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1454511600000,
            'complete': 1455116400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077900',
            'eventId': '6',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1454511600000,
            'complete': 1461250800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077000',
            'eventId': '9',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1454511600000,
            'complete': 1456066800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078200',
            'eventId': '8',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1454511600000,
            'complete': 1460991600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-076400',
            'eventId': '8',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1454598000000,
            'complete': 1456066800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078600',
            'eventId': '10',
            'eventName': 'V|M',
            'source': 'V',
            'target': 'M',
            'start': 1454598000000,
            'complete': 1455116400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-079300',
            'eventId': '10',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1454598000000,
            'complete': 1455202800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-076800',
            'eventId': '9',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1455116400000,
            'complete': 1455462000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-079600',
            'eventId': '8',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1455116400000,
            'complete': 1456412400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-079100',
            'eventId': '10',
            'eventName': 'WW|UU',
            'source': 'WW',
            'target': 'UU',
            'start': 1455116400000,
            'complete': 1456239600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077400',
            'eventId': '10',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1455116400000,
            'complete': 1455462000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078700',
            'eventId': '10',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1455116400000,
            'complete': 1455462000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077100',
            'eventId': '8',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1455116400000,
            'complete': 1455462000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078500',
            'eventId': '9',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1455116400000,
            'complete': 1455462000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078600',
            'eventId': '10',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1455116400000,
            'complete': 1456412400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-079500',
            'eventId': '6',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1455116400000,
            'complete': 1455462000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-079300',
            'eventId': '10',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1455202800000,
            'complete': 1455462000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-079000',
            'eventId': '10',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1455202800000,
            'complete': 1455634800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078300',
            'eventId': '10',
            'eventName': 'V|WW',
            'source': 'V',
            'target': 'WW',
            'start': 1455462000000,
            'complete': 1457881200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-079300',
            'eventId': '10',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1455462000000,
            'complete': 1456066800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-079500',
            'eventId': '6',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1455462000000,
            'complete': 1456066800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077400',
            'eventId': '10',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1455462000000,
            'complete': 1456153200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078700',
            'eventId': '10',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1455462000000,
            'complete': 1456066800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-076800',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1455462000000,
            'complete': 1456412400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078500',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1455462000000,
            'complete': 1457017200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077600',
            'eventId': '10',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1455462000000,
            'complete': 1456844400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077100',
            'eventId': '8',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1455462000000,
            'complete': 1456066800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078100',
            'eventId': '9',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1455548400000,
            'complete': 1455634800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-075900',
            'eventId': '10',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1455634800000,
            'complete': 1456239600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-076700',
            'eventId': '8',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1455634800000,
            'complete': 1459177200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-079000',
            'eventId': '10',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1455634800000,
            'complete': 1456066800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078100',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1455634800000,
            'complete': 1456066800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078000',
            'eventId': '10',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1455634800000,
            'complete': 1455807600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-076500',
            'eventId': '8',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1455721200000,
            'complete': 1456066800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078000',
            'eventId': '10',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1455807600000,
            'complete': 1456412400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-079800',
            'eventId': '9',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1455894000000,
            'complete': 1457881200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-076400',
            'eventId': '8',
            'eventName': 'H|S',
            'source': 'H',
            'target': 'S',
            'start': 1456066800000,
            'complete': 1462287600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077500',
            'eventId': '11',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1456066800000,
            'complete': 1456153200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077200',
            'eventId': '10',
            'eventName': 'J|M',
            'source': 'J',
            'target': 'M',
            'start': 1456066800000,
            'complete': 1456326000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-076900',
            'eventId': '10',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1456066800000,
            'complete': 1456153200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077100',
            'eventId': '8',
            'eventName': 'H|S',
            'source': 'H',
            'target': 'S',
            'start': 1456066800000,
            'complete': 1456412400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-079000',
            'eventId': '10',
            'eventName': 'H|S',
            'source': 'H',
            'target': 'S',
            'start': 1456066800000,
            'complete': 1460386800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077000',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1456066800000,
            'complete': 1456412400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078100',
            'eventId': '9',
            'eventName': 'H|S',
            'source': 'H',
            'target': 'S',
            'start': 1456066800000,
            'complete': 1456412400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-079300',
            'eventId': '10',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1456066800000,
            'complete': 1457017200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078700',
            'eventId': '10',
            'eventName': 'H|S',
            'source': 'H',
            'target': 'S',
            'start': 1456066800000,
            'complete': 1456412400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-076500',
            'eventId': '8',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1456066800000,
            'complete': 1457362800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077300',
            'eventId': '10',
            'eventName': 'H|S',
            'source': 'H',
            'target': 'S',
            'start': 1456066800000,
            'complete': 1456239600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-076900',
            'eventId': '10',
            'eventName': 'H|S',
            'source': 'H',
            'target': 'S',
            'start': 1456153200000,
            'complete': 1457622000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-080200',
            'eventId': '7',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1456153200000,
            'complete': 1459263600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078800',
            'eventId': '9',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1456153200000,
            'complete': 1456412400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077500',
            'eventId': '11',
            'eventName': 'H|S',
            'source': 'H',
            'target': 'S',
            'start': 1456153200000,
            'complete': 1458054000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-076600',
            'eventId': '11',
            'eventName': 'H|S',
            'source': 'H',
            'target': 'S',
            'start': 1456153200000,
            'complete': 1457535600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077400',
            'eventId': '10',
            'eventName': 'H|S',
            'source': 'H',
            'target': 'S',
            'start': 1456153200000,
            'complete': 1461250800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-080500',
            'eventId': '10',
            'eventName': 'V|M',
            'source': 'V',
            'target': 'M',
            'start': 1456153200000,
            'complete': 1467558000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-075900',
            'eventId': '10',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1456239600000,
            'complete': 1456930800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-079100',
            'eventId': '10',
            'eventName': 'D|M',
            'source': 'D',
            'target': 'M',
            'start': 1456239600000,
            'complete': 1457622000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-080600',
            'eventId': '11',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1456239600000,
            'complete': 1500476400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-080400',
            'eventId': '10',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1456239600000,
            'complete': 1459090800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077300',
            'eventId': '10',
            'eventName': 'S|D',
            'source': 'S',
            'target': 'D',
            'start': 1456239600000,
            'complete': 1461682800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077200',
            'eventId': '10',
            'eventName': 'H|S',
            'source': 'H',
            'target': 'S',
            'start': 1456326000000,
            'complete': 1456412400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078400',
            'eventId': '10',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1456412400000,
            'complete': 1456930800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078800',
            'eventId': '9',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1456412400000,
            'complete': 1456844400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077200',
            'eventId': '10',
            'eventName': 'S|D',
            'source': 'S',
            'target': 'D',
            'start': 1456412400000,
            'complete': 1461596400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078100',
            'eventId': '9',
            'eventName': 'S|D',
            'source': 'S',
            'target': 'D',
            'start': 1456412400000,
            'complete': 1461682800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077000',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1456412400000,
            'complete': 1457967600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-076800',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1456412400000,
            'complete': 1458226800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078700',
            'eventId': '10',
            'eventName': 'S|D',
            'source': 'S',
            'target': 'D',
            'start': 1456412400000,
            'complete': 1468162800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078000',
            'eventId': '10',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1456412400000,
            'complete': 1457967600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-079600',
            'eventId': '8',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1456412400000,
            'complete': 1456844400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078600',
            'eventId': '10',
            'eventName': 'J|WW',
            'source': 'J',
            'target': 'WW',
            'start': 1456412400000,
            'complete': 1456930800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077100',
            'eventId': '8',
            'eventName': 'S|D',
            'source': 'S',
            'target': 'D',
            'start': 1456412400000,
            'complete': 1468162800000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-078800',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1456844400000,
            'complete': 1458226800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-079600',
            'eventId': '8',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1456844400000,
            'complete': 1461596400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-080600',
            'eventId': '11',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1456844400000,
            'complete': 1457276400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077600',
            'eventId': '10',
            'eventName': 'H|YY',
            'source': 'H',
            'target': 'YY',
            'start': 1456844400000,
            'complete': 1462287600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078600',
            'eventId': '10',
            'eventName': 'H|V',
            'source': 'H',
            'target': 'V',
            'start': 1456930800000,
            'complete': 1460646000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-075900',
            'eventId': '10',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1456930800000,
            'complete': 1457276400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078400',
            'eventId': '10',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1456930800000,
            'complete': 1457881200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078500',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1457017200000,
            'complete': 1457535600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-079300',
            'eventId': '10',
            'eventName': 'D|D',
            'source': 'D',
            'target': 'D',
            'start': 1457017200000,
            'complete': 1479135600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-080600',
            'eventId': '11',
            'eventName': 'H|S',
            'source': 'H',
            'target': 'S',
            'start': 1457276400000,
            'complete': 1459090800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-075900',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1457276400000,
            'complete': 1459954800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-076500',
            'eventId': '8',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1457362800000,
            'complete': 1498748400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-078500',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1457535600000,
            'complete': 1463497200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-076600',
            'eventId': '11',
            'eventName': 'S|D',
            'source': 'S',
            'target': 'D',
            'start': 1457535600000,
            'complete': 1461682800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-081400',
            'eventId': '11',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1457622000000,
            'complete': 1457967600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-076900',
            'eventId': '10',
            'eventName': 'S|D',
            'source': 'S',
            'target': 'D',
            'start': 1457622000000,
            'complete': 1461682800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-080700',
            'eventId': '7',
            'eventName': 'YY|WW',
            'source': 'YY',
            'target': 'WW',
            'start': 1457622000000,
            'complete': 1460646000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-079100',
            'eventId': '10',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1457622000000,
            'complete': 1458226800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-081400',
            'eventId': '11',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1457622000000,
            'complete': 1469977200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-079800',
            'eventId': '9',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1457881200000,
            'complete': 1458054000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-081800',
            'eventId': '10',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1457881200000,
            'complete': 1458140400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078300',
            'eventId': '10',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1457881200000,
            'complete': 1458486000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078400',
            'eventId': '10',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1457881200000,
            'complete': 1464706800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-081500',
            'eventId': '10',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1457967600000,
            'complete': 1459090800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-081400',
            'eventId': '11',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1457967600000,
            'complete': 1459090800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078000',
            'eventId': '10',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1457967600000,
            'complete': 1459350000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077000',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1457967600000,
            'complete': 1459090800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-079800',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1458054000000,
            'complete': 1459090800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077500',
            'eventId': '11',
            'eventName': 'S|D',
            'source': 'S',
            'target': 'D',
            'start': 1458054000000,
            'complete': 1461596400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-080100',
            'eventId': '8',
            'eventName': 'D|M',
            'source': 'D',
            'target': 'M',
            'start': 1458140400000,
            'complete': 1466348400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-081800',
            'eventId': '10',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1458140400000,
            'complete': 1459090800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-082200',
            'eventId': '10',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1458140400000,
            'complete': 1458226800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-082200',
            'eventId': '10',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1458226800000,
            'complete': 1458486000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-079100',
            'eventId': '10',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1458226800000,
            'complete': 1459436400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078800',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1458226800000,
            'complete': 1465311600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-076800',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1458226800000,
            'complete': 1465311600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-081900',
            'eventId': '6',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1458226800000,
            'complete': 1461250800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078300',
            'eventId': '10',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1458486000000,
            'complete': 1459090800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-082200',
            'eventId': '10',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1458486000000,
            'complete': 1458572400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-072300',
            'eventId': '9',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1458486000000,
            'complete': 1458658800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-074300',
            'eventId': '9',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1458486000000,
            'complete': 1469026800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-082200',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1458572400000,
            'complete': 1461078000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-082700',
            'eventId': '9',
            'eventName': 'YY|WW',
            'source': 'YY',
            'target': 'WW',
            'start': 1458658800000,
            'complete': 1459090800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-082600',
            'eventId': '10',
            'eventName': 'YY|WW',
            'source': 'YY',
            'target': 'WW',
            'start': 1458658800000,
            'complete': 1478790000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-072300',
            'eventId': '9',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1458658800000,
            'complete': 1459263600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-082900',
            'eventId': '9',
            'eventName': 'V|M',
            'source': 'V',
            'target': 'M',
            'start': 1458745200000,
            'complete': 1465484400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-076201',
            'eventId': '12',
            'eventName': 'P|D',
            'source': 'P',
            'target': 'D',
            'start': 1458831600000,
            'complete': 1484146800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-082300',
            'eventId': '9',
            'eventName': 'V|M',
            'source': 'V',
            'target': 'M',
            'start': 1458831600000,
            'complete': 1459782000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-076200',
            'eventId': '6',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1458831600000,
            'complete': 1460905200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-081800',
            'eventId': '10',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1459090800000,
            'complete': 1478703600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-080400',
            'eventId': '10',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1459090800000,
            'complete': 1459350000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077000',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1459090800000,
            'complete': 1462719600000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-080600',
            'eventId': '11',
            'eventName': 'S|D',
            'source': 'S',
            'target': 'D',
            'start': 1459090800000,
            'complete': 1459350000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-079800',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1459090800000,
            'complete': 1487257200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078300',
            'eventId': '10',
            'eventName': 'H|V',
            'source': 'H',
            'target': 'V',
            'start': 1459090800000,
            'complete': 1460214000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-081400',
            'eventId': '11',
            'eventName': 'H|S',
            'source': 'H',
            'target': 'S',
            'start': 1459090800000,
            'complete': 1463670000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-082700',
            'eventId': '9',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1459090800000,
            'complete': 1459263600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-081500',
            'eventId': '10',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1459090800000,
            'complete': 1459177200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-081500',
            'eventId': '10',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1459177200000,
            'complete': 1459263600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-076700',
            'eventId': '8',
            'eventName': 'H|YY',
            'source': 'H',
            'target': 'YY',
            'start': 1459177200000,
            'complete': 1477234800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-072300',
            'eventId': '9',
            'eventName': 'J|M',
            'source': 'J',
            'target': 'M',
            'start': 1459263600000,
            'complete': 1460041200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-083100',
            'eventId': '9',
            'eventName': 'II|WW',
            'source': 'II',
            'target': 'WW',
            'start': 1459263600000,
            'complete': 1459868400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-082700',
            'eventId': '9',
            'eventName': 'J|M',
            'source': 'J',
            'target': 'M',
            'start': 1459263600000,
            'complete': 1459436400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-080200',
            'eventId': '7',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1459263600000,
            'complete': 1459350000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-081500',
            'eventId': '10',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1459263600000,
            'complete': 1459436400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078000',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1459350000000,
            'complete': 1477407600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-080400',
            'eventId': '10',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1459350000000,
            'complete': 1460905200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-080600',
            'eventId': '11',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1459350000000,
            'complete': 1460905200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-080200',
            'eventId': '7',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1459350000000,
            'complete': 1459868400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-079100',
            'eventId': '10',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1459436400000,
            'complete': 1459954800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-082700',
            'eventId': '9',
            'eventName': 'H|YY',
            'source': 'H',
            'target': 'YY',
            'start': 1459436400000,
            'complete': 1484492400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-081500',
            'eventId': '10',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1459436400000,
            'complete': 1465225200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-083200',
            'eventId': '7',
            'eventName': 'YY|M',
            'source': 'YY',
            'target': 'M',
            'start': 1459695600000,
            'complete': 1464274800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-082300',
            'eventId': '9',
            'eventName': 'M|WW',
            'source': 'M',
            'target': 'WW',
            'start': 1459782000000,
            'complete': 1459954800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-083100',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1459868400000,
            'complete': 1459954800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-081600',
            'eventId': '10',
            'eventName': 'D|M',
            'source': 'D',
            'target': 'M',
            'start': 1459868400000,
            'complete': 1460386800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-080200',
            'eventId': '7',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1459868400000,
            'complete': 1477407600000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-079100',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1459954800000,
            'complete': 1462719600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-075900',
            'eventId': '10',
            'eventName': 'J|E',
            'source': 'J',
            'target': 'E',
            'start': 1459954800000,
            'complete': 1500390000000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-082300',
            'eventId': '9',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1459954800000,
            'complete': 1461250800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-083100',
            'eventId': '9',
            'eventName': 'H|II',
            'source': 'H',
            'target': 'II',
            'start': 1459954800000,
            'complete': 1466348400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-083400',
            'eventId': '9',
            'eventName': 'V|WW',
            'source': 'V',
            'target': 'WW',
            'start': 1460041200000,
            'complete': 1460559600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-072300',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1460041200000,
            'complete': 1488985200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078300',
            'eventId': '10',
            'eventName': 'V|E',
            'source': 'V',
            'target': 'E',
            'start': 1460214000000,
            'complete': 1461682800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-081600',
            'eventId': '10',
            'eventName': 'M|WW',
            'source': 'M',
            'target': 'WW',
            'start': 1460386800000,
            'complete': 1460559600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-083500',
            'eventId': '10',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1460386800000,
            'complete': 1460646000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-079000',
            'eventId': '10',
            'eventName': 'S|D',
            'source': 'S',
            'target': 'D',
            'start': 1460386800000,
            'complete': 1467558000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-083400',
            'eventId': '9',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1460559600000,
            'complete': 1460905200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-083600',
            'eventId': '9',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1460559600000,
            'complete': 1460991600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-081600',
            'eventId': '10',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1460559600000,
            'complete': 1462719600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-080700',
            'eventId': '7',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1460646000000,
            'complete': 1461250800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-083500',
            'eventId': '10',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1460646000000,
            'complete': 1460905200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078600',
            'eventId': '10',
            'eventName': 'V|E',
            'source': 'V',
            'target': 'E',
            'start': 1460646000000,
            'complete': 1461164400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-080400',
            'eventId': '10',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1460905200000,
            'complete': 1461855600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-076200',
            'eventId': '6',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1460905200000,
            'complete': 1460991600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-083500',
            'eventId': '10',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1460905200000,
            'complete': 1461510000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-080600',
            'eventId': '11',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1460905200000,
            'complete': 1462892400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-083400',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1460905200000,
            'complete': 1461250800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078200',
            'eventId': '8',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1460991600000,
            'complete': 1461078000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-083600',
            'eventId': '9',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1460991600000,
            'complete': 1461682800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-083700',
            'eventId': '6',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1460991600000,
            'complete': 1461855600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-076200',
            'eventId': '6',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1460991600000,
            'complete': 1462719600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078200',
            'eventId': '8',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1461078000000,
            'complete': 1462719600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-082200',
            'eventId': '10',
            'eventName': 'J|E',
            'source': 'J',
            'target': 'E',
            'start': 1461078000000,
            'complete': 1462287600000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-078600',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1461164400000,
            'complete': 1465916400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077900',
            'eventId': '6',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1461250800000,
            'complete': 1462719600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-075800',
            'eventId': '10',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1461250800000,
            'complete': 1478703600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-080700',
            'eventId': '7',
            'eventName': 'J|M',
            'source': 'J',
            'target': 'M',
            'start': 1461250800000,
            'complete': 1462806000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-081900',
            'eventId': '6',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1461250800000,
            'complete': 1461682800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084200',
            'eventId': '9',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1461250800000,
            'complete': 1463065200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-083400',
            'eventId': '9',
            'eventName': 'H|V',
            'source': 'H',
            'target': 'V',
            'start': 1461250800000,
            'complete': 1461855600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-082300',
            'eventId': '9',
            'eventName': 'H|V',
            'source': 'H',
            'target': 'V',
            'start': 1461250800000,
            'complete': 1464015600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077400',
            'eventId': '10',
            'eventName': 'S|D',
            'source': 'S',
            'target': 'D',
            'start': 1461250800000,
            'complete': 1467558000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-083500',
            'eventId': '10',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1461510000000,
            'complete': 1464188400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077500',
            'eventId': '11',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1461596400000,
            'complete': 1462114800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-079600',
            'eventId': '8',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1461596400000,
            'complete': 1462978800000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-077200',
            'eventId': '10',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1461596400000,
            'complete': 1463497200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-076600',
            'eventId': '11',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1461682800000,
            'complete': 1462719600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078300',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1461682800000,
            'complete': 1464534000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-081900',
            'eventId': '6',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1461682800000,
            'complete': 1462719600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-076900',
            'eventId': '10',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1461682800000,
            'complete': 1462719600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084500',
            'eventId': '9',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1461682800000,
            'complete': 1462287600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-083600',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1461682800000,
            'complete': 1462719600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078100',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1461682800000,
            'complete': 1464620400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-084900',
            'eventId': '10',
            'eventName': 'V|WW',
            'source': 'V',
            'target': 'WW',
            'start': 1461682800000,
            'complete': 1467298800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077300',
            'eventId': '10',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1461682800000,
            'complete': 1462719600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084400',
            'eventId': '10',
            'eventName': 'YY|WW',
            'source': 'YY',
            'target': 'WW',
            'start': 1461769200000,
            'complete': 1462287600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084600',
            'eventId': '10',
            'eventName': 'V|WW',
            'source': 'V',
            'target': 'WW',
            'start': 1461769200000,
            'complete': 1461855600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-083400',
            'eventId': '9',
            'eventName': 'V|E',
            'source': 'V',
            'target': 'E',
            'start': 1461855600000,
            'complete': 1462201200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084600',
            'eventId': '10',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1461855600000,
            'complete': 1462114800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084700',
            'eventId': '10',
            'eventName': 'V|WW',
            'source': 'V',
            'target': 'WW',
            'start': 1461855600000,
            'complete': 1466434800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-080400',
            'eventId': '10',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1461855600000,
            'complete': 1468335600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-083700',
            'eventId': '6',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1461855600000,
            'complete': 1462719600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-085600',
            'eventId': '10',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1462114800000,
            'complete': 1462287600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077500',
            'eventId': '11',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1462114800000,
            'complete': 1464620400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-084600',
            'eventId': '10',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1462114800000,
            'complete': 1462201200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084600',
            'eventId': '10',
            'eventName': 'H|V',
            'source': 'H',
            'target': 'V',
            'start': 1462201200000,
            'complete': 1462806000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-083400',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1462201200000,
            'complete': 1465916400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-084500',
            'eventId': '9',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1462287600000,
            'complete': 1462719600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-076400',
            'eventId': '8',
            'eventName': 'S|D',
            'source': 'S',
            'target': 'D',
            'start': 1462287600000,
            'complete': 1481209200000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-084400',
            'eventId': '10',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1462287600000,
            'complete': 1462719600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077600',
            'eventId': '10',
            'eventName': 'YY|S',
            'source': 'YY',
            'target': 'S',
            'start': 1462287600000,
            'complete': 1494860400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-085600',
            'eventId': '10',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1462287600000,
            'complete': 1462719600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-081600',
            'eventId': '10',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1462719600000,
            'complete': 1464534000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-083600',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1462719600000,
            'complete': 1465311600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084400',
            'eventId': '10',
            'eventName': 'J|M',
            'source': 'J',
            'target': 'M',
            'start': 1462719600000,
            'complete': 1462806000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077900',
            'eventId': '6',
            'eventName': 'J|M',
            'source': 'J',
            'target': 'M',
            'start': 1462719600000,
            'complete': 1462806000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078200',
            'eventId': '8',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1462719600000,
            'complete': 1479654000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077300',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1462719600000,
            'complete': 1467298800000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-084000',
            'eventId': '9',
            'eventName': 'YY|WW',
            'source': 'YY',
            'target': 'WW',
            'start': 1462719600000,
            'complete': 1463670000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-085600',
            'eventId': '10',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1462719600000,
            'complete': 1463324400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-076900',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1462719600000,
            'complete': 1464534000000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-083700',
            'eventId': '6',
            'eventName': 'J|M',
            'source': 'J',
            'target': 'M',
            'start': 1462719600000,
            'complete': 1467298800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-076600',
            'eventId': '11',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1462719600000,
            'complete': 1464620400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-079100',
            'eventId': '10',
            'eventName': 'J|E',
            'source': 'J',
            'target': 'E',
            'start': 1462719600000,
            'complete': 1471878000000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-084500',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1462719600000,
            'complete': 1463583600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084600',
            'eventId': '10',
            'eventName': 'V|E',
            'source': 'V',
            'target': 'E',
            'start': 1462806000000,
            'complete': 1462892400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-080700',
            'eventId': '7',
            'eventName': 'H|YY',
            'source': 'H',
            'target': 'YY',
            'start': 1462806000000,
            'complete': 1485183600000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-084400',
            'eventId': '10',
            'eventName': 'H|YY',
            'source': 'H',
            'target': 'YY',
            'start': 1462806000000,
            'complete': 1464793200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-085200',
            'eventId': '9',
            'eventName': 'V|WW',
            'source': 'V',
            'target': 'WW',
            'start': 1462806000000,
            'complete': 1464274800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-082000',
            'eventId': '7',
            'eventName': 'V|WW',
            'source': 'V',
            'target': 'WW',
            'start': 1462806000000,
            'complete': 1474988400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-068700',
            'eventId': '8',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1462892400000,
            'complete': 1470236400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084600',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1462892400000,
            'complete': 1465916400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-086000',
            'eventId': '6',
            'eventName': 'II|WW',
            'source': 'II',
            'target': 'WW',
            'start': 1462978800000,
            'complete': 1467644400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084200',
            'eventId': '9',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1463065200000,
            'complete': 1463929200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-086400',
            'eventId': '9',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1463324400000,
            'complete': 1465916400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-086500',
            'eventId': '6',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1463324400000,
            'complete': 1472482800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-085600',
            'eventId': '10',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1463324400000,
            'complete': 1465398000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-085000',
            'eventId': '10',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1463324400000,
            'complete': 1466002800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-086200',
            'eventId': '6',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1463324400000,
            'complete': 1463670000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-086300',
            'eventId': '8',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1463324400000,
            'complete': 1464274800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-080901',
            'eventId': '10',
            'eventName': '안전정책팀 (complete)|D',
            'source': '안전정책팀 (complete)',
            'target': 'D',
            'start': 1463410800000,
            'complete': 1493305200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-085900',
            'eventId': '8',
            'eventName': 'YY|M',
            'source': 'YY',
            'target': 'M',
            'start': 1463410800000,
            'complete': 1466348400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-080900',
            'eventId': '7',
            'eventName': 'D|M',
            'source': 'D',
            'target': 'M',
            'start': 1463410800000,
            'complete': 1464274800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-085500',
            'eventId': '9',
            'eventName': 'V|WW',
            'source': 'V',
            'target': 'WW',
            'start': 1463410800000,
            'complete': 1466434800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077200',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1463497200000,
            'complete': 1464534000000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-078500',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1463497200000,
            'complete': 1465916400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-084500',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1463583600000,
            'complete': 1469977200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084000',
            'eventId': '9',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1463670000000,
            'complete': 1464015600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-086200',
            'eventId': '6',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1463670000000,
            'complete': 1464015600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-081400',
            'eventId': '11',
            'eventName': 'S|D',
            'source': 'S',
            'target': 'D',
            'start': 1463670000000,
            'complete': 1467558000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-087200',
            'eventId': '10',
            'eventName': 'D|M',
            'source': 'D',
            'target': 'M',
            'start': 1463929200000,
            'complete': 1465484400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-086900',
            'eventId': '10',
            'eventName': 'YY|M',
            'source': 'YY',
            'target': 'M',
            'start': 1463929200000,
            'complete': 1465916400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084200',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1463929200000,
            'complete': 1464620400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-082300',
            'eventId': '9',
            'eventName': 'V|E',
            'source': 'V',
            'target': 'E',
            'start': 1464015600000,
            'complete': 1469113200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-086200',
            'eventId': '6',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1464015600000,
            'complete': 1464620400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-082500',
            'eventId': '10',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1464015600000,
            'complete': 1464534000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084000',
            'eventId': '9',
            'eventName': 'H|YY',
            'source': 'H',
            'target': 'YY',
            'start': 1464015600000,
            'complete': 1464188400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-086100',
            'eventId': '10',
            'eventName': 'YY|WW',
            'source': 'YY',
            'target': 'WW',
            'start': 1464188400000,
            'complete': 1464620400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-083500',
            'eventId': '10',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1464188400000,
            'complete': 1465225200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084800',
            'eventId': '10',
            'eventName': 'YY|WW',
            'source': 'YY',
            'target': 'WW',
            'start': 1464188400000,
            'complete': 1465916400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084000',
            'eventId': '9',
            'eventName': 'YY|E',
            'source': 'YY',
            'target': 'E',
            'start': 1464188400000,
            'complete': 1464879600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-083200',
            'eventId': '7',
            'eventName': 'M|WW',
            'source': 'M',
            'target': 'WW',
            'start': 1464274800000,
            'complete': 1464534000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-085200',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1464274800000,
            'complete': 1464879600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-086300',
            'eventId': '8',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1464274800000,
            'complete': 1464620400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-080900',
            'eventId': '7',
            'eventName': 'M|WW',
            'source': 'M',
            'target': 'WW',
            'start': 1464274800000,
            'complete': 1464534000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-080900',
            'eventId': '7',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1464534000000,
            'complete': 1464879600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078300',
            'eventId': '10',
            'eventName': 'J|E',
            'source': 'J',
            'target': 'E',
            'start': 1464534000000,
            'complete': 1479740400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-083200',
            'eventId': '7',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1464534000000,
            'complete': 1464879600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-081600',
            'eventId': '10',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1464534000000,
            'complete': 1464879600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-082500',
            'eventId': '10',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1464534000000,
            'complete': 1464793200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084200',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1464620400000,
            'complete': 1470754800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-086100',
            'eventId': '10',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1464620400000,
            'complete': 1464879600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-086300',
            'eventId': '8',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1464620400000,
            'complete': 1464879600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-087400',
            'eventId': '8',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1464620400000,
            'complete': 1466434800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078400',
            'eventId': '10',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1464706800000,
            'complete': 1466607600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-076600',
            'eventId': '11',
            'eventName': 'E|WW',
            'source': 'E',
            'target': 'WW',
            'start': 1464706800000,
            'complete': 1453042800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-082500',
            'eventId': '10',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1464793200000,
            'complete': 1464879600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084400',
            'eventId': '10',
            'eventName': 'YY|E',
            'source': 'YY',
            'target': 'E',
            'start': 1464793200000,
            'complete': 1467298800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084000',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1464879600000,
            'complete': 1469458800000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-082500',
            'eventId': '10',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1464879600000,
            'complete': 1468422000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-083200',
            'eventId': '7',
            'eventName': 'H|YY',
            'source': 'H',
            'target': 'YY',
            'start': 1464879600000,
            'complete': 1478703600000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-085200',
            'eventId': '9',
            'eventName': 'H|V',
            'source': 'H',
            'target': 'V',
            'start': 1464879600000,
            'complete': 1467212400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-086300',
            'eventId': '8',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1464879600000,
            'complete': 1474383600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-080900',
            'eventId': '7',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1464879600000,
            'complete': 1489071600000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-086100',
            'eventId': '10',
            'eventName': 'H|YY',
            'source': 'H',
            'target': 'YY',
            'start': 1464879600000,
            'complete': 1467212400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-081600',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1464879600000,
            'complete': 1466953200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-083500',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1465225200000,
            'complete': 1466953200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084100',
            'eventId': '9',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1465225200000,
            'complete': 1466434800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-081500',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1465225200000,
            'complete': 1466348400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078800',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1465311600000,
            'complete': 1465916400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-083600',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1465311600000,
            'complete': 1468335600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-076800',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1465311600000,
            'complete': 1466348400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-085600',
            'eventId': '10',
            'eventName': 'D|D',
            'source': 'D',
            'target': 'D',
            'start': 1465398000000,
            'complete': 1479135600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-082900',
            'eventId': '9',
            'eventName': 'M|WW',
            'source': 'M',
            'target': 'WW',
            'start': 1465484400000,
            'complete': 1466434800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-087200',
            'eventId': '10',
            'eventName': 'M|WW',
            'source': 'M',
            'target': 'WW',
            'start': 1465484400000,
            'complete': 1465570800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-087200',
            'eventId': '10',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1465570800000,
            'complete': 1467212400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-087700',
            'eventId': '8',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1465830000000,
            'complete': 1473260400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084600',
            'eventId': '10',
            'eventName': 'J|E',
            'source': 'J',
            'target': 'E',
            'start': 1465916400000,
            'complete': 1500476400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-086900',
            'eventId': '10',
            'eventName': 'M|WW',
            'source': 'M',
            'target': 'WW',
            'start': 1465916400000,
            'complete': 1466434800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-086400',
            'eventId': '9',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1465916400000,
            'complete': 1466262000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084800',
            'eventId': '10',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1465916400000,
            'complete': 1467644400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078600',
            'eventId': '10',
            'eventName': 'J|E',
            'source': 'J',
            'target': 'E',
            'start': 1465916400000,
            'complete': 1467644400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-088400',
            'eventId': '9',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1466002800000,
            'complete': 1466607600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-085000',
            'eventId': '10',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1466002800000,
            'complete': 1466348400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-085700',
            'eventId': '10',
            'eventName': 'V|M',
            'source': 'V',
            'target': 'M',
            'start': 1466262000000,
            'complete': 1478012400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-079700',
            'eventId': '9',
            'eventName': 'D|M',
            'source': 'D',
            'target': 'M',
            'start': 1466262000000,
            'complete': 1468940400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-088900',
            'eventId': '9',
            'eventName': 'V|WW',
            'source': 'V',
            'target': 'WW',
            'start': 1466262000000,
            'complete': 1466694000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-086400',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1466262000000,
            'complete': 1467298800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-088800',
            'eventId': '10',
            'eventName': 'V|J',
            'source': 'V',
            'target': 'J',
            'start': 1466262000000,
            'complete': 1467558000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-088700',
            'eventId': '6',
            'eventName': 'V|WW',
            'source': 'V',
            'target': 'WW',
            'start': 1466262000000,
            'complete': 1466607600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-085900',
            'eventId': '8',
            'eventName': 'M|WW',
            'source': 'M',
            'target': 'WW',
            'start': 1466348400000,
            'complete': 1466521200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-081500',
            'eventId': '10',
            'eventName': 'J|E',
            'source': 'J',
            'target': 'E',
            'start': 1466348400000,
            'complete': 1500390000000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-085000',
            'eventId': '10',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1466348400000,
            'complete': 1467558000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-083100',
            'eventId': '9',
            'eventName': 'II|E',
            'source': 'II',
            'target': 'E',
            'start': 1466348400000,
            'complete': 1467730800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-080100',
            'eventId': '8',
            'eventName': 'M|WW',
            'source': 'M',
            'target': 'WW',
            'start': 1466348400000,
            'complete': 1466434800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084100',
            'eventId': '9',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1466434800000,
            'complete': 1466953200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-087400',
            'eventId': '8',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1466434800000,
            'complete': 1466607600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-085500',
            'eventId': '9',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1466434800000,
            'complete': 1466607600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084700',
            'eventId': '10',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1466434800000,
            'complete': 1467558000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-082900',
            'eventId': '9',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1466434800000,
            'complete': 1467730800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-080100',
            'eventId': '8',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1466434800000,
            'complete': 1467558000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-086900',
            'eventId': '10',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1466434800000,
            'complete': 1468249200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-085900',
            'eventId': '8',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1466521200000,
            'complete': 1467644400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-086700',
            'eventId': '10',
            'eventName': 'V|WW',
            'source': 'V',
            'target': 'WW',
            'start': 1466521200000,
            'complete': 1468249200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-089300',
            'eventId': '9',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1466607600000,
            'complete': 1467126000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078400',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1466607600000,
            'complete': 1468422000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-087400',
            'eventId': '8',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1466607600000,
            'complete': 1467298800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-088400',
            'eventId': '9',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1466607600000,
            'complete': 1466694000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-088700',
            'eventId': '6',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1466607600000,
            'complete': 1467298800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-085500',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1466607600000,
            'complete': 1467558000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-088400',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1466694000000,
            'complete': 1467558000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-088900',
            'eventId': '9',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1466694000000,
            'complete': 1466953200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-089800',
            'eventId': '10',
            'eventName': 'V|WW',
            'source': 'V',
            'target': 'WW',
            'start': 1466953200000,
            'complete': 1467644400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-087500',
            'eventId': '9',
            'eventName': 'V|WW',
            'source': 'V',
            'target': 'WW',
            'start': 1466953200000,
            'complete': 1467298800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-088900',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1466953200000,
            'complete': 1467558000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084100',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1466953200000,
            'complete': 1467298800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-089600',
            'eventId': '7',
            'eventName': 'V|WW',
            'source': 'V',
            'target': 'WW',
            'start': 1466953200000,
            'complete': 1469026800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-083500',
            'eventId': '10',
            'eventName': 'J|E',
            'source': 'J',
            'target': 'E',
            'start': 1466953200000,
            'complete': 1500476400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-089500',
            'eventId': '9',
            'eventName': 'V|WW',
            'source': 'V',
            'target': 'WW',
            'start': 1466953200000,
            'complete': 1469026800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-088100',
            'eventId': '8',
            'eventName': 'V|M',
            'source': 'V',
            'target': 'M',
            'start': 1466953200000,
            'complete': 1468940400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-090000',
            'eventId': '10',
            'eventName': 'V|WW',
            'source': 'V',
            'target': 'WW',
            'start': 1466953200000,
            'complete': 1467212400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-081600',
            'eventId': '10',
            'eventName': 'J|E',
            'source': 'J',
            'target': 'E',
            'start': 1466953200000,
            'complete': 1500476400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-089300',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1467126000000,
            'complete': 1467558000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-086100',
            'eventId': '10',
            'eventName': 'YY|E',
            'source': 'YY',
            'target': 'E',
            'start': 1467212400000,
            'complete': 1467298800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-087200',
            'eventId': '10',
            'eventName': 'H|S',
            'source': 'H',
            'target': 'S',
            'start': 1467212400000,
            'complete': 1474902000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-090000',
            'eventId': '10',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1467212400000,
            'complete': 1467558000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-085200',
            'eventId': '9',
            'eventName': 'V|E',
            'source': 'V',
            'target': 'E',
            'start': 1467212400000,
            'complete': 1468162800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-091000',
            'eventId': '7',
            'eventName': 'II|WW',
            'source': 'II',
            'target': 'WW',
            'start': 1467212400000,
            'complete': 1467644400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-091100',
            'eventId': '9',
            'eventName': 'V|WW',
            'source': 'V',
            'target': 'WW',
            'start': 1467212400000,
            'complete': 1467817200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084100',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1467298800000,
            'complete': 1470582000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-087500',
            'eventId': '9',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1467298800000,
            'complete': 1467558000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-089700',
            'eventId': '9',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1467298800000,
            'complete': 1468508400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084400',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1467298800000,
            'complete': 1470841200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-086400',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1467298800000,
            'complete': 1469631600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-087400',
            'eventId': '8',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1467298800000,
            'complete': 1489417200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-088700',
            'eventId': '6',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1467298800000,
            'complete': 1467558000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-086100',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1467298800000,
            'complete': 1469458800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084900',
            'eventId': '10',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1467298800000,
            'complete': 1467558000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-090600',
            'eventId': '8',
            'eventName': 'YY|M',
            'source': 'YY',
            'target': 'M',
            'start': 1467298800000,
            'complete': 1467644400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-087600',
            'eventId': '9',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1467298800000,
            'complete': 1468940400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-080100',
            'eventId': '8',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1467558000000,
            'complete': 1469977200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-085000',
            'eventId': '10',
            'eventName': 'H|S',
            'source': 'H',
            'target': 'S',
            'start': 1467558000000,
            'complete': 1477234800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-089300',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1467558000000,
            'complete': 1472223600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-080500',
            'eventId': '10',
            'eventName': 'M|WW',
            'source': 'M',
            'target': 'WW',
            'start': 1467558000000,
            'complete': 1467644400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-087500',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1467558000000,
            'complete': 1468249200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084900',
            'eventId': '10',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1467558000000,
            'complete': 1467730800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077400',
            'eventId': '10',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1467558000000,
            'complete': 1468249200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-091300',
            'eventId': '9',
            'eventName': 'V|WW',
            'source': 'V',
            'target': 'WW',
            'start': 1467558000000,
            'complete': 1469977200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-085400',
            'eventId': '7',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1467558000000,
            'complete': 1474383600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-081400',
            'eventId': '11',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1467558000000,
            'complete': 1468249200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-088400',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1467558000000,
            'complete': 1469718000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-085500',
            'eventId': '9',
            'eventName': 'H|S',
            'source': 'H',
            'target': 'S',
            'start': 1467558000000,
            'complete': 1469631600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084700',
            'eventId': '10',
            'eventName': 'J|M',
            'source': 'J',
            'target': 'M',
            'start': 1467558000000,
            'complete': 1468940400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-088800',
            'eventId': '10',
            'eventName': 'M|WW',
            'source': 'M',
            'target': 'WW',
            'start': 1467558000000,
            'complete': 1467644400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-088900',
            'eventId': '9',
            'eventName': 'H|V',
            'source': 'H',
            'target': 'V',
            'start': 1467558000000,
            'complete': 1480604400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-079000',
            'eventId': '10',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1467558000000,
            'complete': 1477926000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-090000',
            'eventId': '10',
            'eventName': 'H|V',
            'source': 'H',
            'target': 'V',
            'start': 1467558000000,
            'complete': 1478012400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-085900',
            'eventId': '8',
            'eventName': 'H|YY',
            'source': 'H',
            'target': 'YY',
            'start': 1467644400000,
            'complete': 1473087600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084800',
            'eventId': '10',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1467644400000,
            'complete': 1467730800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-080500',
            'eventId': '10',
            'eventName': 'H|V',
            'source': 'H',
            'target': 'V',
            'start': 1467644400000,
            'complete': 1469113200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-090600',
            'eventId': '8',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1467644400000,
            'complete': 1467817200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-086000',
            'eventId': '6',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1467644400000,
            'complete': 1467903600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-089800',
            'eventId': '10',
            'eventName': 'H|V',
            'source': 'H',
            'target': 'V',
            'start': 1467644400000,
            'complete': 1468249200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-088800',
            'eventId': '10',
            'eventName': 'H|V',
            'source': 'H',
            'target': 'V',
            'start': 1467644400000,
            'complete': 1470236400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-091000',
            'eventId': '7',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1467644400000,
            'complete': 1467903600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-091500',
            'eventId': '10',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1467644400000,
            'complete': 1468508400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084900',
            'eventId': '10',
            'eventName': 'H|V',
            'source': 'H',
            'target': 'V',
            'start': 1467730800000,
            'complete': 1469718000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-083100',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1467730800000,
            'complete': 1470841200000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-082900',
            'eventId': '9',
            'eventName': 'H|V',
            'source': 'H',
            'target': 'V',
            'start': 1467730800000,
            'complete': 1469977200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084800',
            'eventId': '10',
            'eventName': 'H|YY',
            'source': 'H',
            'target': 'YY',
            'start': 1467730800000,
            'complete': 1474815600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-091100',
            'eventId': '9',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1467817200000,
            'complete': 1468249200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-090300',
            'eventId': '7',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1467817200000,
            'complete': 1470668400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-090600',
            'eventId': '8',
            'eventName': 'J|WW',
            'source': 'J',
            'target': 'WW',
            'start': 1467817200000,
            'complete': 1468508400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-091000',
            'eventId': '7',
            'eventName': 'H|II',
            'source': 'H',
            'target': 'II',
            'start': 1467903600000,
            'complete': 1490799600000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-091900',
            'eventId': '8',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1467903600000,
            'complete': 1468767600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078700',
            'eventId': '10',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1468162800000,
            'complete': 1469113200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-085200',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1468162800000,
            'complete': 1470841200000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-081400',
            'eventId': '11',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1468249200000,
            'complete': 1468422000000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-092000',
            'eventId': '9',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1468249200000,
            'complete': 1473087600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-091100',
            'eventId': '9',
            'eventName': 'J|M',
            'source': 'J',
            'target': 'M',
            'start': 1468249200000,
            'complete': 1469718000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-086900',
            'eventId': '10',
            'eventName': 'H|YY',
            'source': 'H',
            'target': 'YY',
            'start': 1468249200000,
            'complete': 1482937200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-092100',
            'eventId': '9',
            'eventName': 'V|WW',
            'source': 'V',
            'target': 'WW',
            'start': 1468249200000,
            'complete': 1468508400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077400',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1468249200000,
            'complete': 1468422000000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-087500',
            'eventId': '9',
            'eventName': 'H|V',
            'source': 'H',
            'target': 'V',
            'start': 1468249200000,
            'complete': 1468422000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-086700',
            'eventId': '10',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1468249200000,
            'complete': 1468767600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-089800',
            'eventId': '10',
            'eventName': 'V|E',
            'source': 'V',
            'target': 'E',
            'start': 1468249200000,
            'complete': 1470236400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-080400',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1468335600000,
            'complete': 1470841200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-083600',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1468335600000,
            'complete': 1468422000000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-092200',
            'eventId': '6',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1468335600000,
            'complete': 1468422000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-082500',
            'eventId': '10',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1468422000000,
            'complete': 1468508400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-092200',
            'eventId': '6',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1468422000000,
            'complete': 1468767600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-087500',
            'eventId': '9',
            'eventName': 'V|E',
            'source': 'V',
            'target': 'E',
            'start': 1468422000000,
            'complete': 1468508400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078400',
            'eventId': '10',
            'eventName': 'J|E',
            'source': 'J',
            'target': 'E',
            'start': 1468422000000,
            'complete': 1479740400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-092100',
            'eventId': '9',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1468508400000,
            'complete': 1468854000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-087500',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1468508400000,
            'complete': 1471878000000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-089700',
            'eventId': '9',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1468508400000,
            'complete': 1468767600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-082500',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1468508400000,
            'complete': 1470841200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-090600',
            'eventId': '8',
            'eventName': 'H|S',
            'source': 'H',
            'target': 'S',
            'start': 1468508400000,
            'complete': 1468854000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-091500',
            'eventId': '10',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1468508400000,
            'complete': 1468767600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-092200',
            'eventId': '6',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1468767600000,
            'complete': 1470150000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-089700',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1468767600000,
            'complete': 1470150000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-091900',
            'eventId': '8',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1468767600000,
            'complete': 1469458800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-091500',
            'eventId': '10',
            'eventName': 'J|M',
            'source': 'J',
            'target': 'M',
            'start': 1468767600000,
            'complete': 1468940400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-086700',
            'eventId': '10',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1468767600000,
            'complete': 1469458800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-092700',
            'eventId': '9',
            'eventName': 'V|WW',
            'source': 'V',
            'target': 'WW',
            'start': 1468767600000,
            'complete': 1469718000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-091400',
            'eventId': '9',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1468854000000,
            'complete': 1470668400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-092100',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1468854000000,
            'complete': 1469458800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-092900',
            'eventId': '10',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1468854000000,
            'complete': 1468940400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-092400',
            'eventId': '9',
            'eventName': 'V|WW',
            'source': 'V',
            'target': 'WW',
            'start': 1468854000000,
            'complete': 1471359600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-092300',
            'eventId': '10',
            'eventName': 'V|M',
            'source': 'V',
            'target': 'M',
            'start': 1468854000000,
            'complete': 1478185200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-091800',
            'eventId': '10',
            'eventName': 'V|WW',
            'source': 'V',
            'target': 'WW',
            'start': 1468854000000,
            'complete': 1469718000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-088100',
            'eventId': '8',
            'eventName': 'M|WW',
            'source': 'M',
            'target': 'WW',
            'start': 1468940400000,
            'complete': 1469026800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-079700',
            'eventId': '9',
            'eventName': 'M|WW',
            'source': 'M',
            'target': 'WW',
            'start': 1468940400000,
            'complete': 1469026800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-091500',
            'eventId': '10',
            'eventName': 'H|S',
            'source': 'H',
            'target': 'S',
            'start': 1468940400000,
            'complete': 1476284400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-087600',
            'eventId': '9',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1468940400000,
            'complete': 1469372400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-092900',
            'eventId': '10',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1468940400000,
            'complete': 1469026800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084700',
            'eventId': '10',
            'eventName': 'H|V',
            'source': 'H',
            'target': 'V',
            'start': 1468940400000,
            'complete': 1469718000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-092900',
            'eventId': '10',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1469026800000,
            'complete': 1471532400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-089500',
            'eventId': '9',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1469026800000,
            'complete': 1469458800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-079700',
            'eventId': '9',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1469026800000,
            'complete': 1470236400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-074300',
            'eventId': '9',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1469026800000,
            'complete': 1469631600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-088100',
            'eventId': '8',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1469026800000,
            'complete': 1470150000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-089600',
            'eventId': '7',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1469026800000,
            'complete': 1469631600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078700',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1469113200000,
            'complete': 1471878000000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-080500',
            'eventId': '10',
            'eventName': 'V|E',
            'source': 'V',
            'target': 'E',
            'start': 1469113200000,
            'complete': 1469458800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-082300',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1469113200000,
            'complete': 1471878000000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-087600',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1469372400000,
            'complete': 1470236400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-086100',
            'eventId': '10',
            'eventName': 'J|E',
            'source': 'J',
            'target': 'E',
            'start': 1469458800000,
            'complete': 1500476400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-092100',
            'eventId': '9',
            'eventName': 'H|V',
            'source': 'H',
            'target': 'V',
            'start': 1469458800000,
            'complete': 1470841200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-091900',
            'eventId': '8',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1469458800000,
            'complete': 1470150000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-080500',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1469458800000,
            'complete': 1471878000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-086700',
            'eventId': '10',
            'eventName': 'H|V',
            'source': 'H',
            'target': 'V',
            'start': 1469458800000,
            'complete': 1469977200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-089500',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1469458800000,
            'complete': 1470236400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-093500',
            'eventId': '7',
            'eventName': 'V|WW',
            'source': 'V',
            'target': 'WW',
            'start': 1469458800000,
            'complete': 1484492400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-086800',
            'eventId': '9',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1469631600000,
            'complete': 1473260400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-085500',
            'eventId': '9',
            'eventName': 'S|V',
            'source': 'S',
            'target': 'V',
            'start': 1469631600000,
            'complete': 1470582000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-074300',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1469631600000,
            'complete': 1470754800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-089600',
            'eventId': '7',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1469631600000,
            'complete': 1470236400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-086400',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1469631600000,
            'complete': 1470582000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084700',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1469718000000,
            'complete': 1471878000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-092700',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1469718000000,
            'complete': 1470236400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084900',
            'eventId': '10',
            'eventName': 'V|E',
            'source': 'V',
            'target': 'E',
            'start': 1469718000000,
            'complete': 1469977200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-093300',
            'eventId': '9',
            'eventName': 'YY|WW',
            'source': 'YY',
            'target': 'WW',
            'start': 1469718000000,
            'complete': 1470668400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-091100',
            'eventId': '9',
            'eventName': 'H|V',
            'source': 'H',
            'target': 'V',
            'start': 1469718000000,
            'complete': 1470063600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-093400',
            'eventId': '10',
            'eventName': 'YY|M',
            'source': 'YY',
            'target': 'M',
            'start': 1469718000000,
            'complete': 1474902000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-091800',
            'eventId': '10',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1469718000000,
            'complete': 1470236400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-088400',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1469718000000,
            'complete': 1473692400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-080100',
            'eventId': '8',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1469977200000,
            'complete': 1474815600000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-086700',
            'eventId': '10',
            'eventName': 'V|E',
            'source': 'V',
            'target': 'E',
            'start': 1469977200000,
            'complete': 1470841200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-081400',
            'eventId': '11',
            'eventName': 'E|WW',
            'source': 'E',
            'target': 'WW',
            'start': 1469977200000,
            'complete': 1457622000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084900',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1469977200000,
            'complete': 1471878000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084500',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1469977200000,
            'complete': 1470754800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-082900',
            'eventId': '9',
            'eventName': 'V|E',
            'source': 'V',
            'target': 'E',
            'start': 1469977200000,
            'complete': 1473606000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-093900',
            'eventId': '6',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1469977200000,
            'complete': 1470063600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-091300',
            'eventId': '9',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1469977200000,
            'complete': 1470236400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-091100',
            'eventId': '9',
            'eventName': 'V|E',
            'source': 'V',
            'target': 'E',
            'start': 1470063600000,
            'complete': 1474210800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-093900',
            'eventId': '6',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1470063600000,
            'complete': 1470150000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-094100',
            'eventId': '6',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1470150000000,
            'complete': 1473606000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-089700',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1470150000000,
            'complete': 1488898800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-091900',
            'eventId': '8',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1470150000000,
            'complete': 1491318000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-094200',
            'eventId': '8',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1470150000000,
            'complete': 1470668400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-088100',
            'eventId': '8',
            'eventName': 'H|V',
            'source': 'H',
            'target': 'V',
            'start': 1470150000000,
            'complete': 1471359600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-093900',
            'eventId': '6',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1470150000000,
            'complete': 1470841200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-068700',
            'eventId': '8',
            'eventName': 'J|M',
            'source': 'J',
            'target': 'M',
            'start': 1470236400000,
            'complete': 1470322800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-089500',
            'eventId': '9',
            'eventName': 'H|V',
            'source': 'H',
            'target': 'V',
            'start': 1470236400000,
            'complete': 1471791600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-091800',
            'eventId': '10',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1470236400000,
            'complete': 1470322800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-089600',
            'eventId': '7',
            'eventName': 'H|V',
            'source': 'H',
            'target': 'V',
            'start': 1470236400000,
            'complete': 1470927600000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-087600',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1470236400000,
            'complete': 1479222000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-088800',
            'eventId': '10',
            'eventName': 'V|E',
            'source': 'V',
            'target': 'E',
            'start': 1470236400000,
            'complete': 1470582000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-079700',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1470236400000,
            'complete': 1481641200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-091300',
            'eventId': '9',
            'eventName': 'J|M',
            'source': 'J',
            'target': 'M',
            'start': 1470236400000,
            'complete': 1470582000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-089800',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1470236400000,
            'complete': 1474556400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-092700',
            'eventId': '9',
            'eventName': 'H|V',
            'source': 'H',
            'target': 'V',
            'start': 1470236400000,
            'complete': 1471359600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-093701',
            'eventId': '11',
            'eventName': '정유생산공장 (complete)|V',
            'source': '정유생산공장 (complete)',
            'target': 'V',
            'start': 1470322800000,
            'complete': 1484233200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-093700',
            'eventId': '8',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1470322800000,
            'complete': 1470754800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-068700',
            'eventId': '8',
            'eventName': 'M|A',
            'source': 'M',
            'target': 'A',
            'start': 1470322800000,
            'complete': 1471446000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-091800',
            'eventId': '10',
            'eventName': 'H|V',
            'source': 'H',
            'target': 'V',
            'start': 1470322800000,
            'complete': 1470754800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-094300',
            'eventId': '10',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1470582000000,
            'complete': 1471446000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-088800',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1470582000000,
            'complete': 1474556400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-086400',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1470582000000,
            'complete': 1474556400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-091300',
            'eventId': '9',
            'eventName': 'H|V',
            'source': 'H',
            'target': 'V',
            'start': 1470582000000,
            'complete': 1470754800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084100',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1470582000000,
            'complete': 1471446000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-085500',
            'eventId': '9',
            'eventName': 'V|E',
            'source': 'V',
            'target': 'E',
            'start': 1470582000000,
            'complete': 1470754800000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-094200',
            'eventId': '8',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1470668400000,
            'complete': 1470754800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-093300',
            'eventId': '9',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1470668400000,
            'complete': 1470841200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-095000',
            'eventId': '9',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1470668400000,
            'complete': 1474383600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-090300',
            'eventId': '7',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1470668400000,
            'complete': 1470754800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-091400',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1470668400000,
            'complete': 1470841200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-074300',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1470754800000,
            'complete': 1484665200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-091800',
            'eventId': '10',
            'eventName': 'V|E',
            'source': 'V',
            'target': 'E',
            'start': 1470754800000,
            'complete': 1470927600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-090300',
            'eventId': '7',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1470754800000,
            'complete': 1470927600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-094200',
            'eventId': '8',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1470754800000,
            'complete': 1470841200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-091300',
            'eventId': '9',
            'eventName': 'V|E',
            'source': 'V',
            'target': 'E',
            'start': 1470754800000,
            'complete': 1470927600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084500',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1470754800000,
            'complete': 1474556400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-093700',
            'eventId': '8',
            'eventName': 'H|V',
            'source': 'H',
            'target': 'V',
            'start': 1470754800000,
            'complete': 1473087600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084200',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1470754800000,
            'complete': 1478617200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-086700',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1470841200000,
            'complete': 1471878000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084400',
            'eventId': '10',
            'eventName': 'J|E',
            'source': 'J',
            'target': 'E',
            'start': 1470841200000,
            'complete': 1500390000000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-093300',
            'eventId': '9',
            'eventName': 'H|YY',
            'source': 'H',
            'target': 'YY',
            'start': 1470841200000,
            'complete': 1476889200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-092100',
            'eventId': '9',
            'eventName': 'V|E',
            'source': 'V',
            'target': 'E',
            'start': 1470841200000,
            'complete': 1470927600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-082500',
            'eventId': '10',
            'eventName': 'J|E',
            'source': 'J',
            'target': 'E',
            'start': 1470841200000,
            'complete': 1500476400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-080400',
            'eventId': '10',
            'eventName': 'J|E',
            'source': 'J',
            'target': 'E',
            'start': 1470841200000,
            'complete': 1500476400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-094200',
            'eventId': '8',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1470841200000,
            'complete': 1487775600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-091400',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1470841200000,
            'complete': 1471618800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-091300',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1470927600000,
            'complete': 1474556400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-091800',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1470927600000,
            'complete': 1474556400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-090300',
            'eventId': '7',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1470927600000,
            'complete': 1489503600000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-094800',
            'eventId': '10',
            'eventName': 'V|WW',
            'source': 'V',
            'target': 'WW',
            'start': 1470927600000,
            'complete': 1471359600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-092100',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1470927600000,
            'complete': 1474556400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-092500',
            'eventId': '9',
            'eventName': 'D|M',
            'source': 'D',
            'target': 'M',
            'start': 1471186800000,
            'complete': 1484838000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-093600',
            'eventId': '9',
            'eventName': 'V|WW',
            'source': 'V',
            'target': 'WW',
            'start': 1471186800000,
            'complete': 1472050800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-092400',
            'eventId': '9',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1471359600000,
            'complete': 1471532400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-095100',
            'eventId': '8',
            'eventName': 'YY|WW',
            'source': 'YY',
            'target': 'WW',
            'start': 1471359600000,
            'complete': 1474988400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-088100',
            'eventId': '8',
            'eventName': 'V|E',
            'source': 'V',
            'target': 'E',
            'start': 1471359600000,
            'complete': 1471446000000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-094800',
            'eventId': '10',
            'eventName': 'J|M',
            'source': 'J',
            'target': 'M',
            'start': 1471359600000,
            'complete': 1471446000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-092700',
            'eventId': '9',
            'eventName': 'V|E',
            'source': 'V',
            'target': 'E',
            'start': 1471359600000,
            'complete': 1471791600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-094400',
            'eventId': '8',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1471359600000,
            'complete': 1479740400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-094700',
            'eventId': '10',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1471359600000,
            'complete': 1472569200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-068700',
            'eventId': '8',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1471446000000,
            'complete': 1476111600000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-094300',
            'eventId': '10',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1471446000000,
            'complete': 1473606000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-094800',
            'eventId': '10',
            'eventName': 'H|S',
            'source': 'H',
            'target': 'S',
            'start': 1471446000000,
            'complete': 1471878000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084100',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1471446000000,
            'complete': 1474556400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-092900',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1471532400000,
            'complete': 1471878000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-095600',
            'eventId': '8',
            'eventName': 'D|M',
            'source': 'D',
            'target': 'M',
            'start': 1471532400000,
            'complete': 1474470000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-092400',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1471532400000,
            'complete': 1473606000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-091400',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1471618800000,
            'complete': 1472482800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-092700',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1471791600000,
            'complete': 1474556400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-089500',
            'eventId': '9',
            'eventName': 'V|E',
            'source': 'V',
            'target': 'E',
            'start': 1471791600000,
            'complete': 1471878000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-094800',
            'eventId': '10',
            'eventName': 'S|V',
            'source': 'S',
            'target': 'V',
            'start': 1471878000000,
            'complete': 1486479600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-089500',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1471878000000,
            'complete': 1474556400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-084700',
            'eventId': '10',
            'eventName': 'J|E',
            'source': 'J',
            'target': 'E',
            'start': 1471878000000,
            'complete': 1480950000000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-092900',
            'eventId': '10',
            'eventName': 'J|E',
            'source': 'J',
            'target': 'E',
            'start': 1471878000000,
            'complete': 1474210800000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-086700',
            'eventId': '10',
            'eventName': 'J|E',
            'source': 'J',
            'target': 'E',
            'start': 1471878000000,
            'complete': 1501599600000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-084900',
            'eventId': '10',
            'eventName': 'J|E',
            'source': 'J',
            'target': 'E',
            'start': 1471878000000,
            'complete': 1473692400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-080500',
            'eventId': '10',
            'eventName': 'J|E',
            'source': 'J',
            'target': 'E',
            'start': 1471878000000,
            'complete': 1473692400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-093600',
            'eventId': '9',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1472050800000,
            'complete': 1472569200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-094900',
            'eventId': '10',
            'eventName': 'V|WW',
            'source': 'V',
            'target': 'WW',
            'start': 1472137200000,
            'complete': 1472655600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-095300',
            'eventId': '6',
            'eventName': 'V|WW',
            'source': 'V',
            'target': 'WW',
            'start': 1472137200000,
            'complete': 1474470000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-089300',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1472223600000,
            'complete': 1473260400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-086500',
            'eventId': '6',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1472482800000,
            'complete': 1473606000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-091400',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1472482800000,
            'complete': 1474556400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-095500',
            'eventId': '9',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1472569200000,
            'complete': 1473260400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-095200',
            'eventId': '10',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1472569200000,
            'complete': 1473260400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-093600',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1472569200000,
            'complete': 1473606000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-094700',
            'eventId': '10',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1472569200000,
            'complete': 1473606000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-094900',
            'eventId': '10',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1472655600000,
            'complete': 1473087600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-093700',
            'eventId': '8',
            'eventName': 'V|E',
            'source': 'V',
            'target': 'E',
            'start': 1473087600000,
            'complete': 1473606000000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-094900',
            'eventId': '10',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1473087600000,
            'complete': 1474297200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-085900',
            'eventId': '8',
            'eventName': 'YY|E',
            'source': 'YY',
            'target': 'E',
            'start': 1473087600000,
            'complete': 1476370800000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-092000',
            'eventId': '9',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1473087600000,
            'complete': 1473606000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-086800',
            'eventId': '9',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1473260400000,
            'complete': 1474815600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-095500',
            'eventId': '9',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1473260400000,
            'complete': 1473606000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-089300',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1473260400000,
            'complete': 1474556400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-095200',
            'eventId': '10',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1473260400000,
            'complete': 1473606000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-087700',
            'eventId': '8',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1473260400000,
            'complete': 1473606000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-096500',
            'eventId': '9',
            'eventName': 'V|WW',
            'source': 'V',
            'target': 'WW',
            'start': 1473346800000,
            'complete': 1479135600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-094100',
            'eventId': '6',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1473606000000,
            'complete': 1473692400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-092400',
            'eventId': '9',
            'eventName': 'H|V',
            'source': 'H',
            'target': 'V',
            'start': 1473606000000,
            'complete': 1474815600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-087700',
            'eventId': '8',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1473606000000,
            'complete': 1475074800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-082900',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1473606000000,
            'complete': 1474556400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-095500',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1473606000000,
            'complete': 1474297200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-094700',
            'eventId': '10',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1473606000000,
            'complete': 1488812400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-092000',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1473606000000,
            'complete': 1475074800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-094300',
            'eventId': '10',
            'eventName': 'H|S',
            'source': 'H',
            'target': 'S',
            'start': 1473606000000,
            'complete': 1484146800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-093600',
            'eventId': '9',
            'eventName': 'H|V',
            'source': 'H',
            'target': 'V',
            'start': 1473606000000,
            'complete': 1474815600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-095200',
            'eventId': '10',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1473606000000,
            'complete': 1475074800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-088400',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1473692400000,
            'complete': 1474556400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-094100',
            'eventId': '6',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1473692400000,
            'complete': 1475074800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-096600',
            'eventId': '9',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1474038000000,
            'complete': 1476111600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-091100',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1474210800000,
            'complete': 1474556400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-097000',
            'eventId': '8',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1474297200000,
            'complete': 1477839600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-096900',
            'eventId': '9',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1474297200000,
            'complete': 1481641200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-094900',
            'eventId': '10',
            'eventName': 'H|V',
            'source': 'H',
            'target': 'V',
            'start': 1474297200000,
            'complete': 1475506800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-095500',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1474297200000,
            'complete': 1475161200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-097100',
            'eventId': '9',
            'eventName': 'D|M',
            'source': 'D',
            'target': 'M',
            'start': 1474383600000,
            'complete': 1484838000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-085400',
            'eventId': '7',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1474383600000,
            'complete': 1475074800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-095000',
            'eventId': '9',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1474383600000,
            'complete': 1474815600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-086300',
            'eventId': '8',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1474383600000,
            'complete': 1474988400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-095600',
            'eventId': '8',
            'eventName': 'M|WW',
            'source': 'M',
            'target': 'WW',
            'start': 1474470000000,
            'complete': 1474988400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-097200',
            'eventId': '8',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1474470000000,
            'complete': 1479394800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-095300',
            'eventId': '6',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1474470000000,
            'complete': 1474556400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-097500',
            'eventId': '7',
            'eventName': 'V|M',
            'source': 'V',
            'target': 'M',
            'start': 1474470000000,
            'complete': 1475593200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-089800',
            'eventId': '10',
            'eventName': 'J|E',
            'source': 'J',
            'target': 'E',
            'start': 1474556400000,
            'complete': 1475074800000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-095300',
            'eventId': '6',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1474556400000,
            'complete': 1474815600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-088800',
            'eventId': '10',
            'eventName': 'J|E',
            'source': 'J',
            'target': 'E',
            'start': 1474556400000,
            'complete': 1475074800000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-091800',
            'eventId': '10',
            'eventName': 'J|E',
            'source': 'J',
            'target': 'E',
            'start': 1474556400000,
            'complete': 1475074800000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-096300',
            'eventId': '6',
            'eventName': 'YY|WW',
            'source': 'YY',
            'target': 'WW',
            'start': 1474642800000,
            'complete': 1475506800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-086800',
            'eventId': '9',
            'eventName': 'J|M',
            'source': 'J',
            'target': 'M',
            'start': 1474815600000,
            'complete': 1474988400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-097400',
            'eventId': '10',
            'eventName': 'YY|WW',
            'source': 'YY',
            'target': 'WW',
            'start': 1474815600000,
            'complete': 1475506800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-092400',
            'eventId': '9',
            'eventName': 'V|E',
            'source': 'V',
            'target': 'E',
            'start': 1474815600000,
            'complete': 1476025200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-095000',
            'eventId': '9',
            'eventName': 'J|M',
            'source': 'J',
            'target': 'M',
            'start': 1474815600000,
            'complete': 1474902000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-094000',
            'eventId': '10',
            'eventName': 'YY|WW',
            'source': 'YY',
            'target': 'WW',
            'start': 1474815600000,
            'complete': 1477321200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-093600',
            'eventId': '9',
            'eventName': 'V|E',
            'source': 'V',
            'target': 'E',
            'start': 1474815600000,
            'complete': 1476025200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084800',
            'eventId': '10',
            'eventName': 'YY|E',
            'source': 'YY',
            'target': 'E',
            'start': 1474815600000,
            'complete': 1481814000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-097700',
            'eventId': '4',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1474902000000,
            'complete': 1508684400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-087200',
            'eventId': '10',
            'eventName': 'S|D',
            'source': 'S',
            'target': 'D',
            'start': 1474902000000,
            'complete': 1477839600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-095000',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1474902000000,
            'complete': 1476630000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-093400',
            'eventId': '10',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1474902000000,
            'complete': 1475074800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-086800',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1474988400000,
            'complete': 1476630000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-095600',
            'eventId': '8',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1474988400000,
            'complete': 1475161200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-097900',
            'eventId': '9',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1474988400000,
            'complete': 1477926000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-082000',
            'eventId': '7',
            'eventName': 'H|V',
            'source': 'H',
            'target': 'V',
            'start': 1474988400000,
            'complete': 1475506800000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-095100',
            'eventId': '8',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1474988400000,
            'complete': 1475161200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-093400',
            'eventId': '10',
            'eventName': 'J|WW',
            'source': 'J',
            'target': 'WW',
            'start': 1475074800000,
            'complete': 1475506800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-097800',
            'eventId': '8',
            'eventName': 'YY|WW',
            'source': 'YY',
            'target': 'WW',
            'start': 1475074800000,
            'complete': 1481468400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-087700',
            'eventId': '8',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1475074800000,
            'complete': 1482937200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-095200',
            'eventId': '10',
            'eventName': 'H|S',
            'source': 'H',
            'target': 'S',
            'start': 1475074800000,
            'complete': 1488121200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-092000',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1475074800000,
            'complete': 1489330800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-085400',
            'eventId': '7',
            'eventName': 'J|M',
            'source': 'J',
            'target': 'M',
            'start': 1475074800000,
            'complete': 1479135600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-095600',
            'eventId': '8',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1475161200000,
            'complete': 1486652400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-095500',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1475161200000,
            'complete': 1508079600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-095100',
            'eventId': '8',
            'eventName': 'J|M',
            'source': 'J',
            'target': 'M',
            'start': 1475161200000,
            'complete': 1475506800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-095100',
            'eventId': '8',
            'eventName': 'H|S',
            'source': 'H',
            'target': 'S',
            'start': 1475506800000,
            'complete': 1477494000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-094900',
            'eventId': '10',
            'eventName': 'V|E',
            'source': 'V',
            'target': 'E',
            'start': 1475506800000,
            'complete': 1478617200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-098300',
            'eventId': '9',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1475506800000,
            'complete': 1475679600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-097400',
            'eventId': '10',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1475506800000,
            'complete': 1477234800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-096400',
            'eventId': '9',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1475506800000,
            'complete': 1479049200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-096300',
            'eventId': '6',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1475506800000,
            'complete': 1477234800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-093400',
            'eventId': '10',
            'eventName': 'H|YY',
            'source': 'H',
            'target': 'YY',
            'start': 1475506800000,
            'complete': 1480431600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-097500',
            'eventId': '7',
            'eventName': 'M|WW',
            'source': 'M',
            'target': 'WW',
            'start': 1475593200000,
            'complete': 1476111600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-098000',
            'eventId': '8',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1475679600000,
            'complete': 1483628400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-098300',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1475679600000,
            'complete': 1475766000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-098200',
            'eventId': '10',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1475766000000,
            'complete': 1476025200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-098300',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1475766000000,
            'complete': 1476543600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-093600',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1476025200000,
            'complete': 1479222000000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-098200',
            'eventId': '10',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1476025200000,
            'complete': 1476111600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-092400',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1476025200000,
            'complete': 1479222000000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-097500',
            'eventId': '7',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1476111600000,
            'complete': 1477321200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-098200',
            'eventId': '10',
            'eventName': 'H|S',
            'source': 'H',
            'target': 'S',
            'start': 1476111600000,
            'complete': 1476198000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-096600',
            'eventId': '9',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1476111600000,
            'complete': 1477580400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-098200',
            'eventId': '10',
            'eventName': 'S|D',
            'source': 'S',
            'target': 'D',
            'start': 1476198000000,
            'complete': 1476716400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-091500',
            'eventId': '10',
            'eventName': 'S|D',
            'source': 'S',
            'target': 'D',
            'start': 1476284400000,
            'complete': 1481122800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-098700',
            'eventId': '11',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1476370800000,
            'complete': 1497452400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-098300',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1476543600000,
            'complete': 1476630000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-095000',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1476630000000,
            'complete': 1477580400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-086800',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1476630000000,
            'complete': 1477580400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-098300',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1476630000000,
            'complete': 1479135600000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-098200',
            'eventId': '10',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1476716400000,
            'complete': 1476802800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-098200',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1476802800000,
            'complete': 1479135600000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-098600',
            'eventId': '10',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1476802800000,
            'complete': 1479394800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-093300',
            'eventId': '9',
            'eventName': 'YY|E',
            'source': 'YY',
            'target': 'E',
            'start': 1476889200000,
            'complete': 1477926000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-099600',
            'eventId': '8',
            'eventName': 'D|M',
            'source': 'D',
            'target': 'M',
            'start': 1476975600000,
            'complete': 1478617200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-096300',
            'eventId': '6',
            'eventName': 'J|M',
            'source': 'J',
            'target': 'M',
            'start': 1477234800000,
            'complete': 1479999600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-076700',
            'eventId': '8',
            'eventName': 'YY|E',
            'source': 'YY',
            'target': 'E',
            'start': 1477234800000,
            'complete': 1480518000000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-085000',
            'eventId': '10',
            'eventName': 'S|D',
            'source': 'S',
            'target': 'D',
            'start': 1477234800000,
            'complete': 1477321200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-097400',
            'eventId': '10',
            'eventName': 'J|M',
            'source': 'J',
            'target': 'M',
            'start': 1477234800000,
            'complete': 1479740400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-085000',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1477321200000,
            'complete': 1481641200000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-099500',
            'eventId': '9',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1477321200000,
            'complete': 1478012400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-097500',
            'eventId': '7',
            'eventName': 'H|V',
            'source': 'H',
            'target': 'V',
            'start': 1477321200000,
            'complete': 1478703600000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-083300',
            'eventId': '10',
            'eventName': 'V|M',
            'source': 'V',
            'target': 'M',
            'start': 1477321200000,
            'complete': 1482073200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-094000',
            'eventId': '10',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1477321200000,
            'complete': 1477494000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-098900',
            'eventId': '9',
            'eventName': 'V|WW',
            'source': 'V',
            'target': 'WW',
            'start': 1477321200000,
            'complete': 1477926000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-093800',
            'eventId': '6',
            'eventName': 'V|M',
            'source': 'V',
            'target': 'M',
            'start': 1477321200000,
            'complete': 1482159600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078000',
            'eventId': '10',
            'eventName': 'J|E',
            'source': 'J',
            'target': 'E',
            'start': 1477407600000,
            'complete': 1479740400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-094000',
            'eventId': '10',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1477494000000,
            'complete': 1477926000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-086800',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1477580400000,
            'complete': 1492527600000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-099800',
            'eventId': '9',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1477580400000,
            'complete': 1478012400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100500',
            'eventId': '8',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1477580400000,
            'complete': 1478012400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-096600',
            'eventId': '9',
            'eventName': 'J|M',
            'source': 'J',
            'target': 'M',
            'start': 1477580400000,
            'complete': 1477839600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100700',
            'eventId': '9',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1477580400000,
            'complete': 1478617200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100200',
            'eventId': '9',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1477580400000,
            'complete': 1478098800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-095000',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1477580400000,
            'complete': 1492527600000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-099200',
            'eventId': '10',
            'eventName': 'D|M',
            'source': 'D',
            'target': 'M',
            'start': 1477580400000,
            'complete': 1478617200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100400',
            'eventId': '10',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1477580400000,
            'complete': 1477926000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100600',
            'eventId': '9',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1477580400000,
            'complete': 1478617200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-099400',
            'eventId': '9',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1477580400000,
            'complete': 1482937200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100100',
            'eventId': '9',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1477580400000,
            'complete': 1478790000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100300',
            'eventId': '10',
            'eventName': 'D|M',
            'source': 'D',
            'target': 'M',
            'start': 1477580400000,
            'complete': 1478617200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100000',
            'eventId': '9',
            'eventName': 'D|M',
            'source': 'D',
            'target': 'M',
            'start': 1477580400000,
            'complete': 1478617200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-101000',
            'eventId': '8',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1477839600000,
            'complete': 1478012400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-096600',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1477839600000,
            'complete': 1496070000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-087200',
            'eventId': '10',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1477839600000,
            'complete': 1478617200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-097000',
            'eventId': '8',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1477839600000,
            'complete': 1478098800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-099900',
            'eventId': '9',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1477926000000,
            'complete': 1478098800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-093300',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1477926000000,
            'complete': 1481641200000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-079000',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1477926000000,
            'complete': 1479135600000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-097900',
            'eventId': '9',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1477926000000,
            'complete': 1478185200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-098900',
            'eventId': '9',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1477926000000,
            'complete': 1478617200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-094000',
            'eventId': '10',
            'eventName': 'H|S',
            'source': 'H',
            'target': 'S',
            'start': 1477926000000,
            'complete': 1481814000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100400',
            'eventId': '10',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1477926000000,
            'complete': 1478703600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-085700',
            'eventId': '10',
            'eventName': 'M|WW',
            'source': 'M',
            'target': 'WW',
            'start': 1478012400000,
            'complete': 1478098800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100500',
            'eventId': '8',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1478012400000,
            'complete': 1478185200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-099800',
            'eventId': '9',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1478012400000,
            'complete': 1478185200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-090000',
            'eventId': '10',
            'eventName': 'V|E',
            'source': 'V',
            'target': 'E',
            'start': 1478012400000,
            'complete': 1478098800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-101000',
            'eventId': '8',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1478012400000,
            'complete': 1479308400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-099500',
            'eventId': '9',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1478012400000,
            'complete': 1478098800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-085700',
            'eventId': '10',
            'eventName': 'H|V',
            'source': 'H',
            'target': 'V',
            'start': 1478098800000,
            'complete': 1479308400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-090000',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1478098800000,
            'complete': 1481641200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100200',
            'eventId': '9',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1478098800000,
            'complete': 1478185200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-099500',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1478098800000,
            'complete': 1479308400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-099900',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1478098800000,
            'complete': 1479049200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-097000',
            'eventId': '8',
            'eventName': 'J|M',
            'source': 'J',
            'target': 'M',
            'start': 1478098800000,
            'complete': 1479740400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-092300',
            'eventId': '10',
            'eventName': 'M|WW',
            'source': 'M',
            'target': 'WW',
            'start': 1478185200000,
            'complete': 1478530800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100200',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1478185200000,
            'complete': 1479049200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-097900',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1478185200000,
            'complete': 1479135600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100500',
            'eventId': '8',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1478185200000,
            'complete': 1479049200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-099800',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1478185200000,
            'complete': 1479049200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-092300',
            'eventId': '10',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1478530800000,
            'complete': 1479222000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-088000',
            'eventId': '8',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1478530800000,
            'complete': 1480604400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-095700',
            'eventId': '10',
            'eventName': 'YY|WW',
            'source': 'YY',
            'target': 'WW',
            'start': 1478530800000,
            'complete': 1479135600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100000',
            'eventId': '9',
            'eventName': 'M|WW',
            'source': 'M',
            'target': 'WW',
            'start': 1478617200000,
            'complete': 1478790000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-098900',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1478617200000,
            'complete': 1488466800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100300',
            'eventId': '10',
            'eventName': 'M|WW',
            'source': 'M',
            'target': 'WW',
            'start': 1478617200000,
            'complete': 1478790000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-094900',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1478617200000,
            'complete': 1481641200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-087200',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1478617200000,
            'complete': 1492527600000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-099600',
            'eventId': '8',
            'eventName': 'M|WW',
            'source': 'M',
            'target': 'WW',
            'start': 1478617200000,
            'complete': 1478790000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084200',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1478617200000,
            'complete': 1479222000000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-099200',
            'eventId': '10',
            'eventName': 'M|WW',
            'source': 'M',
            'target': 'WW',
            'start': 1478617200000,
            'complete': 1478790000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-101600',
            'eventId': '10',
            'eventName': 'YY|WW',
            'source': 'YY',
            'target': 'WW',
            'start': 1478617200000,
            'complete': 1479135600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100700',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1478617200000,
            'complete': 1479222000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-101500',
            'eventId': '10',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1478617200000,
            'complete': 1479135600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100600',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1478617200000,
            'complete': 1479135600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100400',
            'eventId': '10',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1478703600000,
            'complete': 1480258800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-081800',
            'eventId': '10',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1478703600000,
            'complete': 1479740400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-075800',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1478703600000,
            'complete': 1479135600000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-099200',
            'eventId': '10',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1478790000000,
            'complete': 1479049200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100100',
            'eventId': '9',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1478790000000,
            'complete': 1479049200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-102100',
            'eventId': '9',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1478790000000,
            'complete': 1481468400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100300',
            'eventId': '10',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1478790000000,
            'complete': 1479135600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-082600',
            'eventId': '10',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1478790000000,
            'complete': 1479308400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-102200',
            'eventId': '7',
            'eventName': 'YY|WW',
            'source': 'YY',
            'target': 'WW',
            'start': 1478790000000,
            'complete': 1479135600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-099600',
            'eventId': '8',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1478790000000,
            'complete': 1479135600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100000',
            'eventId': '9',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1478790000000,
            'complete': 1479049200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-101200',
            'eventId': '7',
            'eventName': 'YY|WW',
            'source': 'YY',
            'target': 'WW',
            'start': 1478962800000,
            'complete': 1479740400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-097600',
            'eventId': '8',
            'eventName': 'YY|J',
            'source': 'YY',
            'target': 'J',
            'start': 1478962800000,
            'complete': 1500476400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100200',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1479049200000,
            'complete': 1480431600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-096400',
            'eventId': '9',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1479049200000,
            'complete': 1479308400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100000',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1479049200000,
            'complete': 1480604400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-099800',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1479049200000,
            'complete': 1479222000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-099200',
            'eventId': '10',
            'eventName': 'H|S',
            'source': 'H',
            'target': 'S',
            'start': 1479049200000,
            'complete': 1481036400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-099900',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1479049200000,
            'complete': 1479999600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100100',
            'eventId': '9',
            'eventName': 'J|M',
            'source': 'J',
            'target': 'M',
            'start': 1479049200000,
            'complete': 1479654000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100500',
            'eventId': '8',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1479049200000,
            'complete': 1486306800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-101600',
            'eventId': '10',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1479135600000,
            'complete': 1479740400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-102200',
            'eventId': '7',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1479135600000,
            'complete': 1479308400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-101500',
            'eventId': '10',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1479135600000,
            'complete': 1479222000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-095700',
            'eventId': '10',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1479135600000,
            'complete': 1479222000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-085400',
            'eventId': '7',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1479135600000,
            'complete': 1495378800000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-099600',
            'eventId': '8',
            'eventName': 'H|S',
            'source': 'H',
            'target': 'S',
            'start': 1479135600000,
            'complete': 1486306800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-079300',
            'eventId': '10',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1479135600000,
            'complete': 1507734000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100300',
            'eventId': '10',
            'eventName': 'H|S',
            'source': 'H',
            'target': 'S',
            'start': 1479135600000,
            'complete': 1480431600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100600',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1479135600000,
            'complete': 1491836400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-085600',
            'eventId': '10',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1479135600000,
            'complete': 1507734000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-097900',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1479135600000,
            'complete': 1495119600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-096500',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1479135600000,
            'complete': 1479999600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-087600',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1479222000000,
            'complete': 1480863600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-099800',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1479222000000,
            'complete': 1479740400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-095700',
            'eventId': '10',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1479222000000,
            'complete': 1479308400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100700',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1479222000000,
            'complete': 1481641200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-101500',
            'eventId': '10',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1479222000000,
            'complete': 1483542000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-092300',
            'eventId': '10',
            'eventName': 'H|V',
            'source': 'H',
            'target': 'V',
            'start': 1479222000000,
            'complete': 1479826800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-099500',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1479308400000,
            'complete': 1495983600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-096400',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1479308400000,
            'complete': 1489676400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-102200',
            'eventId': '7',
            'eventName': 'J|M',
            'source': 'J',
            'target': 'M',
            'start': 1479308400000,
            'complete': 1479740400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-101900',
            'eventId': '8',
            'eventName': 'D|J',
            'source': 'D',
            'target': 'J',
            'start': 1479308400000,
            'complete': 1499353200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-101000',
            'eventId': '8',
            'eventName': 'J|M',
            'source': 'J',
            'target': 'M',
            'start': 1479308400000,
            'complete': 1479394800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-095700',
            'eventId': '10',
            'eventName': 'H|YY',
            'source': 'H',
            'target': 'YY',
            'start': 1479308400000,
            'complete': 1480345200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-085700',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1479308400000,
            'complete': 1481641200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-082600',
            'eventId': '10',
            'eventName': 'J|M',
            'source': 'J',
            'target': 'M',
            'start': 1479308400000,
            'complete': 1479999600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-101000',
            'eventId': '8',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1479394800000,
            'complete': 1483369200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-098600',
            'eventId': '10',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1479394800000,
            'complete': 1479999600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-102600',
            'eventId': '9',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1479394800000,
            'complete': 1482246000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-097200',
            'eventId': '8',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1479394800000,
            'complete': 1479999600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100100',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1479654000000,
            'complete': 1481036400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-102500',
            'eventId': '9',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1479654000000,
            'complete': 1486998000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-078200',
            'eventId': '8',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1479654000000,
            'complete': 1479740400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-103200',
            'eventId': '10',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1479740400000,
            'complete': 1479826800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-101600',
            'eventId': '10',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1479740400000,
            'complete': 1479826800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-101200',
            'eventId': '7',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1479740400000,
            'complete': 1479826800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-099100',
            'eventId': '9',
            'eventName': 'D|M',
            'source': 'D',
            'target': 'M',
            'start': 1479740400000,
            'complete': 1481036400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-099800',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1479740400000,
            'complete': 1484233200000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-102200',
            'eventId': '7',
            'eventName': 'H|YY',
            'source': 'H',
            'target': 'YY',
            'start': 1479740400000,
            'complete': 1481727600000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-097000',
            'eventId': '8',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1479740400000,
            'complete': 1488121200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-081800',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1479740400000,
            'complete': 1481641200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-094400',
            'eventId': '8',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1479740400000,
            'complete': 1480345200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-097400',
            'eventId': '10',
            'eventName': 'H|YY',
            'source': 'H',
            'target': 'YY',
            'start': 1479740400000,
            'complete': 1480345200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-103200',
            'eventId': '10',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1479826800000,
            'complete': 1479999600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-101600',
            'eventId': '10',
            'eventName': 'H|YY',
            'source': 'H',
            'target': 'YY',
            'start': 1479826800000,
            'complete': 1481036400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-092300',
            'eventId': '10',
            'eventName': 'V|E',
            'source': 'V',
            'target': 'E',
            'start': 1479826800000,
            'complete': 1483455600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-101200',
            'eventId': '7',
            'eventName': 'J|M',
            'source': 'J',
            'target': 'M',
            'start': 1479826800000,
            'complete': 1481036400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-103800',
            'eventId': '9',
            'eventName': 'II|WW',
            'source': 'II',
            'target': 'WW',
            'start': 1479913200000,
            'complete': 1480518000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-103200',
            'eventId': '10',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1479999600000,
            'complete': 1481036400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-096300',
            'eventId': '6',
            'eventName': 'M|YY',
            'source': 'M',
            'target': 'YY',
            'start': 1479999600000,
            'complete': 1481209200000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-096500',
            'eventId': '9',
            'eventName': 'H|V',
            'source': 'H',
            'target': 'V',
            'start': 1479999600000,
            'complete': 1494601200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-098600',
            'eventId': '10',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1479999600000,
            'complete': 1480950000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-082600',
            'eventId': '10',
            'eventName': 'H|YY',
            'source': 'H',
            'target': 'YY',
            'start': 1479999600000,
            'complete': 1484838000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-097200',
            'eventId': '8',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1479999600000,
            'complete': 1483542000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-099900',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1479999600000,
            'complete': 1480518000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100400',
            'eventId': '10',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1480258800000,
            'complete': 1494774000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-094400',
            'eventId': '8',
            'eventName': 'J|M',
            'source': 'J',
            'target': 'M',
            'start': 1480345200000,
            'complete': 1481122800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-097400',
            'eventId': '10',
            'eventName': 'YY|E',
            'source': 'YY',
            'target': 'E',
            'start': 1480345200000,
            'complete': 1481814000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-101100',
            'eventId': '9',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1480345200000,
            'complete': 1483887600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-098400',
            'eventId': '8',
            'eventName': 'V|WW',
            'source': 'V',
            'target': 'WW',
            'start': 1480345200000,
            'complete': 1483628400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-104400',
            'eventId': '8',
            'eventName': 'D|A',
            'source': 'D',
            'target': 'A',
            'start': 1480345200000,
            'complete': 1480431600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-095900',
            'eventId': '9',
            'eventName': 'D|M',
            'source': 'D',
            'target': 'M',
            'start': 1480345200000,
            'complete': 1486047600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-099000',
            'eventId': '9',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1480345200000,
            'complete': 1483974000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-095700',
            'eventId': '10',
            'eventName': 'YY|E',
            'source': 'YY',
            'target': 'E',
            'start': 1480345200000,
            'complete': 1485961200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-103900',
            'eventId': '10',
            'eventName': 'V|M',
            'source': 'V',
            'target': 'M',
            'start': 1480345200000,
            'complete': 1481036400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-093400',
            'eventId': '10',
            'eventName': 'YY|E',
            'source': 'YY',
            'target': 'E',
            'start': 1480431600000,
            'complete': 1481814000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-104400',
            'eventId': '8',
            'eventName': 'A|WW',
            'source': 'A',
            'target': 'WW',
            'start': 1480431600000,
            'complete': 1480518000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100200',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1480431600000,
            'complete': 1481122800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100300',
            'eventId': '10',
            'eventName': 'S|D',
            'source': 'S',
            'target': 'D',
            'start': 1480431600000,
            'complete': 1490713200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-104400',
            'eventId': '8',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1480518000000,
            'complete': 1480604400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-103800',
            'eventId': '9',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1480518000000,
            'complete': 1481036400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-104500',
            'eventId': '9',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1480518000000,
            'complete': 1485097200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-099900',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1480518000000,
            'complete': 1483369200000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-101800',
            'eventId': '10',
            'eventName': 'D|M',
            'source': 'D',
            'target': 'M',
            'start': 1480604400000,
            'complete': 1484060400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-104100',
            'eventId': '6',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1480604400000,
            'complete': 1482246000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-088900',
            'eventId': '9',
            'eventName': 'V|E',
            'source': 'V',
            'target': 'E',
            'start': 1480604400000,
            'complete': 1489330800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-103300',
            'eventId': '8',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1480604400000,
            'complete': 1482246000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100000',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1480604400000,
            'complete': 1482246000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-104400',
            'eventId': '8',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1480604400000,
            'complete': 1482332400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-088000',
            'eventId': '8',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1480604400000,
            'complete': 1481122800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-087600',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1480863600000,
            'complete': 1483369200000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-098600',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1480950000000,
            'complete': 1483369200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-101600',
            'eventId': '10',
            'eventName': 'YY|E',
            'source': 'YY',
            'target': 'E',
            'start': 1481036400000,
            'complete': 1483628400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-101200',
            'eventId': '7',
            'eventName': 'H|YY',
            'source': 'H',
            'target': 'YY',
            'start': 1481036400000,
            'complete': 1483887600000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-099200',
            'eventId': '10',
            'eventName': 'S|D',
            'source': 'S',
            'target': 'D',
            'start': 1481036400000,
            'complete': 1488985200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-103200',
            'eventId': '10',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1481036400000,
            'complete': 1482159600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100100',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1481036400000,
            'complete': 1484146800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-099100',
            'eventId': '9',
            'eventName': 'M|WW',
            'source': 'M',
            'target': 'WW',
            'start': 1481036400000,
            'complete': 1481468400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-103800',
            'eventId': '9',
            'eventName': 'H|II',
            'source': 'H',
            'target': 'II',
            'start': 1481036400000,
            'complete': 1483369200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-098700',
            'eventId': '11',
            'eventName': 'M|WW',
            'source': 'M',
            'target': 'WW',
            'start': 1481036400000,
            'complete': 1481468400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-103900',
            'eventId': '10',
            'eventName': 'M|WW',
            'source': 'M',
            'target': 'WW',
            'start': 1481036400000,
            'complete': 1481468400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-104300',
            'eventId': '8',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1481036400000,
            'complete': 1482246000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-088000',
            'eventId': '8',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1481122800000,
            'complete': 1485270000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-094400',
            'eventId': '8',
            'eventName': 'H|S',
            'source': 'H',
            'target': 'S',
            'start': 1481122800000,
            'complete': 1485961200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100200',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1481122800000,
            'complete': 1483369200000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-091500',
            'eventId': '10',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1481122800000,
            'complete': 1481641200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-099100',
            'eventId': '9',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1481468400000,
            'complete': 1483542000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-102100',
            'eventId': '9',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1481468400000,
            'complete': 1481641200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-098700',
            'eventId': '11',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1481468400000,
            'complete': 1482332400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-103900',
            'eventId': '10',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1481468400000,
            'complete': 1482332400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-097800',
            'eventId': '8',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1481468400000,
            'complete': 1481727600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-105400',
            'eventId': '9',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1481554800000,
            'complete': 1482332400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-085700',
            'eventId': '10',
            'eventName': 'J|E',
            'source': 'J',
            'target': 'E',
            'start': 1481641200000,
            'complete': 1500476400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-090000',
            'eventId': '10',
            'eventName': 'J|E',
            'source': 'J',
            'target': 'E',
            'start': 1481641200000,
            'complete': 1487602800000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-079700',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1481641200000,
            'complete': 1485356400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-094900',
            'eventId': '10',
            'eventName': 'J|E',
            'source': 'J',
            'target': 'E',
            'start': 1481641200000,
            'complete': 1500476400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-096900',
            'eventId': '9',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1481641200000,
            'complete': 1481727600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-102100',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1481641200000,
            'complete': 1484233200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100700',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1481641200000,
            'complete': 1482246000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-105200',
            'eventId': '8',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1481641200000,
            'complete': 1482937200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-081800',
            'eventId': '10',
            'eventName': 'J|E',
            'source': 'J',
            'target': 'E',
            'start': 1481641200000,
            'complete': 1497970800000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-091500',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1481641200000,
            'complete': 1483455600000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-096900',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1481727600000,
            'complete': 1484233200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-104800',
            'eventId': '7',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1481727600000,
            'complete': 1483628400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-097800',
            'eventId': '8',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1481727600000,
            'complete': 1485183600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-094000',
            'eventId': '10',
            'eventName': 'S|YY',
            'source': 'S',
            'target': 'YY',
            'start': 1481814000000,
            'complete': 1494342000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-093400',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1481814000000,
            'complete': 1483369200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-097400',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1481814000000,
            'complete': 1483455600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084800',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1481814000000,
            'complete': 1486393200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-104600',
            'eventId': '10',
            'eventName': 'V|WW',
            'source': 'V',
            'target': 'WW',
            'start': 1482073200000,
            'complete': 1483542000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-083300',
            'eventId': '10',
            'eventName': 'M|WW',
            'source': 'M',
            'target': 'WW',
            'start': 1482073200000,
            'complete': 1482159600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-083300',
            'eventId': '10',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1482159600000,
            'complete': 1484146800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-093800',
            'eventId': '6',
            'eventName': 'M|WW',
            'source': 'M',
            'target': 'WW',
            'start': 1482159600000,
            'complete': 1482246000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-103200',
            'eventId': '10',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1482159600000,
            'complete': 1483974000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100700',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1482246000000,
            'complete': 1503500400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-105600',
            'eventId': '8',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1482246000000,
            'complete': 1482937200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-104100',
            'eventId': '6',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1482246000000,
            'complete': 1483369200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-104300',
            'eventId': '8',
            'eventName': 'WW|A',
            'source': 'WW',
            'target': 'A',
            'start': 1482246000000,
            'complete': 1482678000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-093800',
            'eventId': '6',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1482246000000,
            'complete': 1483974000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-103300',
            'eventId': '8',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1482246000000,
            'complete': 1482764400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-102600',
            'eventId': '9',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1482246000000,
            'complete': 1482332400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100000',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1482246000000,
            'complete': 1483369200000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-105400',
            'eventId': '9',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1482332400000,
            'complete': 1483369200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-098700',
            'eventId': '11',
            'eventName': 'H|S',
            'source': 'H',
            'target': 'S',
            'start': 1482332400000,
            'complete': 1487775600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-103900',
            'eventId': '10',
            'eventName': 'H|V',
            'source': 'H',
            'target': 'V',
            'start': 1482332400000,
            'complete': 1486911600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-104400',
            'eventId': '8',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1482332400000,
            'complete': 1483887600000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-102600',
            'eventId': '9',
            'eventName': 'J|M',
            'source': 'J',
            'target': 'M',
            'start': 1482332400000,
            'complete': 1483369200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-105900',
            'eventId': '6',
            'eventName': 'YY|WW',
            'source': 'YY',
            'target': 'WW',
            'start': 1482418800000,
            'complete': 1482937200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-103000',
            'eventId': '8',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1482418800000,
            'complete': 1482937200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-104300',
            'eventId': '8',
            'eventName': 'A|M',
            'source': 'A',
            'target': 'M',
            'start': 1482678000000,
            'complete': 1482764400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-103300',
            'eventId': '8',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1482764400000,
            'complete': 1484233200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-104300',
            'eventId': '8',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1482764400000,
            'complete': 1484233200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-105900',
            'eventId': '6',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1482937200000,
            'complete': 1484146800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-105600',
            'eventId': '8',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1482937200000,
            'complete': 1484233200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-105200',
            'eventId': '8',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1482937200000,
            'complete': 1483369200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-099400',
            'eventId': '9',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1482937200000,
            'complete': 1483542000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-087700',
            'eventId': '8',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1482937200000,
            'complete': 1483974000000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-103000',
            'eventId': '8',
            'eventName': 'J|M',
            'source': 'J',
            'target': 'M',
            'start': 1482937200000,
            'complete': 1483282800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-086900',
            'eventId': '10',
            'eventName': 'YY|E',
            'source': 'YY',
            'target': 'E',
            'start': 1482937200000,
            'complete': 1484233200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-106000',
            'eventId': '13',
            'eventName': 'D|D',
            'source': 'D',
            'target': 'D',
            'start': 1482937200000,
            'complete': 1500217200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-103000',
            'eventId': '8',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1483282800000,
            'complete': 1484665200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-098600',
            'eventId': '10',
            'eventName': 'J|E',
            'source': 'J',
            'target': 'E',
            'start': 1483369200000,
            'complete': 1487602800000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-104100',
            'eventId': '6',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1483369200000,
            'complete': 1484233200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-101000',
            'eventId': '8',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1483369200000,
            'complete': 1483974000000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-105400',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1483369200000,
            'complete': 1485183600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-105200',
            'eventId': '8',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1483369200000,
            'complete': 1484665200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-102600',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1483369200000,
            'complete': 1494514800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-103800',
            'eventId': '9',
            'eventName': 'II|E',
            'source': 'II',
            'target': 'E',
            'start': 1483369200000,
            'complete': 1483455600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-093400',
            'eventId': '10',
            'eventName': 'J|E',
            'source': 'J',
            'target': 'E',
            'start': 1483369200000,
            'complete': 1487602800000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-103800',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1483455600000,
            'complete': 1486393200000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-092300',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1483455600000,
            'complete': 1491836400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-098800',
            'eventId': '9',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1483455600000,
            'complete': 1484233200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-097400',
            'eventId': '10',
            'eventName': 'J|E',
            'source': 'J',
            'target': 'E',
            'start': 1483455600000,
            'complete': 1500476400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-099400',
            'eventId': '9',
            'eventName': 'J|M',
            'source': 'J',
            'target': 'M',
            'start': 1483542000000,
            'complete': 1485270000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-099100',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1483542000000,
            'complete': 1491750000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-097200',
            'eventId': '8',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1483542000000,
            'complete': 1502290800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-101500',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1483542000000,
            'complete': 1491836400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-104600',
            'eventId': '10',
            'eventName': 'J|M',
            'source': 'J',
            'target': 'M',
            'start': 1483542000000,
            'complete': 1484060400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-098000',
            'eventId': '8',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1483628400000,
            'complete': 1484060400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-098400',
            'eventId': '8',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1483628400000,
            'complete': 1485270000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-101600',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1483628400000,
            'complete': 1486393200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-104800',
            'eventId': '7',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1483628400000,
            'complete': 1483974000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-101100',
            'eventId': '9',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1483887600000,
            'complete': 1484060400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-103200',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1483974000000,
            'complete': 1486393200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-099000',
            'eventId': '9',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1483974000000,
            'complete': 1484146800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-104800',
            'eventId': '7',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1483974000000,
            'complete': 1484233200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-104600',
            'eventId': '10',
            'eventName': 'H|V',
            'source': 'H',
            'target': 'V',
            'start': 1484060400000,
            'complete': 1484146800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-098000',
            'eventId': '8',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1484060400000,
            'complete': 1484233200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-101800',
            'eventId': '10',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1484060400000,
            'complete': 1484233200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-101100',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1484060400000,
            'complete': 1488812400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-083300',
            'eventId': '10',
            'eventName': 'H|V',
            'source': 'H',
            'target': 'V',
            'start': 1484146800000,
            'complete': 1485097200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-104600',
            'eventId': '10',
            'eventName': 'V|E',
            'source': 'V',
            'target': 'E',
            'start': 1484146800000,
            'complete': 1485874800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-105300',
            'eventId': '9',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1484146800000,
            'complete': 1484665200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-102700',
            'eventId': '8',
            'eventName': 'V|A',
            'source': 'V',
            'target': 'A',
            'start': 1484146800000,
            'complete': 1488466800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-094300',
            'eventId': '10',
            'eventName': 'S|D',
            'source': 'S',
            'target': 'D',
            'start': 1484146800000,
            'complete': 1484233200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100100',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1484146800000,
            'complete': 1484578800000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-076201',
            'eventId': '12',
            'eventName': 'D|D',
            'source': 'D',
            'target': 'D',
            'start': 1484146800000,
            'complete': 1500217200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-105900',
            'eventId': '6',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1484146800000,
            'complete': 1490626800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-099000',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1484146800000,
            'complete': 1485961200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-098000',
            'eventId': '8',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1484233200000,
            'complete': 1484751600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-098800',
            'eventId': '9',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1484233200000,
            'complete': 1484751600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-096900',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1484233200000,
            'complete': 1495033200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-105600',
            'eventId': '8',
            'eventName': 'J|M',
            'source': 'J',
            'target': 'M',
            'start': 1484233200000,
            'complete': 1484838000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-104300',
            'eventId': '8',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1484233200000,
            'complete': 1484751600000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-101800',
            'eventId': '10',
            'eventName': 'J|WW',
            'source': 'J',
            'target': 'WW',
            'start': 1484233200000,
            'complete': 1485097200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-086900',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1484233200000,
            'complete': 1486393200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-102100',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1484233200000,
            'complete': 1484751600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-104800',
            'eventId': '7',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1484233200000,
            'complete': 1494946800000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-103300',
            'eventId': '8',
            'eventName': 'H|S',
            'source': 'H',
            'target': 'S',
            'start': 1484233200000,
            'complete': 1484665200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-093701',
            'eventId': '11',
            'eventName': 'V|J',
            'source': 'V',
            'target': 'J',
            'start': 1484233200000,
            'complete': 1506265200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-094300',
            'eventId': '10',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1484233200000,
            'complete': 1484492400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-082700',
            'eventId': '9',
            'eventName': 'YY|E',
            'source': 'YY',
            'target': 'E',
            'start': 1484492400000,
            'complete': 1493650800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-094300',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1484492400000,
            'complete': 1486479600000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-093500',
            'eventId': '7',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1484492400000,
            'complete': 1484578800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-103400',
            'eventId': '9',
            'eventName': 'V|M',
            'source': 'V',
            'target': 'M',
            'start': 1484578800000,
            'complete': 1484838000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-093500',
            'eventId': '7',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1484578800000,
            'complete': 1485183600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-103000',
            'eventId': '8',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1484665200000,
            'complete': 1485356400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-105300',
            'eventId': '9',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1484665200000,
            'complete': 1485270000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-074300',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1484665200000,
            'complete': 1486047600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-105200',
            'eventId': '8',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1484665200000,
            'complete': 1487084400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-098800',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1484751600000,
            'complete': 1490281200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-098000',
            'eventId': '8',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1484751600000,
            'complete': 1485356400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-102100',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1484751600000,
            'complete': 1486047600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-097100',
            'eventId': '9',
            'eventName': 'M|WW',
            'source': 'M',
            'target': 'WW',
            'start': 1484838000000,
            'complete': 1485097200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-103400',
            'eventId': '9',
            'eventName': 'M|WW',
            'source': 'M',
            'target': 'WW',
            'start': 1484838000000,
            'complete': 1485874800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-092500',
            'eventId': '9',
            'eventName': 'M|WW',
            'source': 'M',
            'target': 'WW',
            'start': 1484838000000,
            'complete': 1485097200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-105600',
            'eventId': '8',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1484838000000,
            'complete': 1495465200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-082600',
            'eventId': '10',
            'eventName': 'YY|E',
            'source': 'YY',
            'target': 'E',
            'start': 1484838000000,
            'complete': 1486220400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-097100',
            'eventId': '9',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1485097200000,
            'complete': 1490540400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-083300',
            'eventId': '10',
            'eventName': 'V|E',
            'source': 'V',
            'target': 'E',
            'start': 1485097200000,
            'complete': 1485874800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-104500',
            'eventId': '9',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1485097200000,
            'complete': 1485183600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-092500',
            'eventId': '9',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1485097200000,
            'complete': 1490540400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-101800',
            'eventId': '10',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1485097200000,
            'complete': 1486911600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-093500',
            'eventId': '7',
            'eventName': 'H|V',
            'source': 'H',
            'target': 'V',
            'start': 1485183600000,
            'complete': 1489935600000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-104500',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1485183600000,
            'complete': 1490540400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-097800',
            'eventId': '8',
            'eventName': 'H|YY',
            'source': 'H',
            'target': 'YY',
            'start': 1485183600000,
            'complete': 1494514800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-105400',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1485183600000,
            'complete': 1488121200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100900',
            'eventId': '11',
            'eventName': 'V|J',
            'source': 'V',
            'target': 'J',
            'start': 1485270000000,
            'complete': 1507734000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-099400',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1485270000000,
            'complete': 1487084400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-105300',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1485270000000,
            'complete': 1486306800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-088000',
            'eventId': '8',
            'eventName': 'H|S',
            'source': 'H',
            'target': 'S',
            'start': 1485270000000,
            'complete': 1489417200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-098400',
            'eventId': '8',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1485270000000,
            'complete': 1485961200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-096200',
            'eventId': '10',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1485356400000,
            'complete': 1501513200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-079700',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1485356400000,
            'complete': 1492700400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-099700',
            'eventId': '12',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1485356400000,
            'complete': 1495638000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-083300',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1485874800000,
            'complete': 1487602800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-103400',
            'eventId': '9',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1485874800000,
            'complete': 1487257200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-104600',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1485874800000,
            'complete': 1491836400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-098400',
            'eventId': '8',
            'eventName': 'H|V',
            'source': 'H',
            'target': 'V',
            'start': 1485961200000,
            'complete': 1491404400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-095700',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1485961200000,
            'complete': 1486393200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-099000',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1485961200000,
            'complete': 1488121200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-074300',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1486047600000,
            'complete': 1500303600000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-095900',
            'eventId': '9',
            'eventName': 'M|WW',
            'source': 'M',
            'target': 'WW',
            'start': 1486047600000,
            'complete': 1486479600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-102100',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1486047600000,
            'complete': 1486393200000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-082600',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1486220400000,
            'complete': 1487602800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100500',
            'eventId': '8',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1486306800000,
            'complete': 1488207600000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-105300',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1486306800000,
            'complete': 1492095600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-084800',
            'eventId': '10',
            'eventName': 'J|E',
            'source': 'J',
            'target': 'E',
            'start': 1486393200000,
            'complete': 1500390000000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-095700',
            'eventId': '10',
            'eventName': 'J|E',
            'source': 'J',
            'target': 'E',
            'start': 1486393200000,
            'complete': 1500390000000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-086900',
            'eventId': '10',
            'eventName': 'J|E',
            'source': 'J',
            'target': 'E',
            'start': 1486393200000,
            'complete': 1500390000000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-103200',
            'eventId': '10',
            'eventName': 'J|E',
            'source': 'J',
            'target': 'E',
            'start': 1486393200000,
            'complete': 1487602800000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-101600',
            'eventId': '10',
            'eventName': 'J|E',
            'source': 'J',
            'target': 'E',
            'start': 1486393200000,
            'complete': 1487602800000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-094800',
            'eventId': '10',
            'eventName': 'V|E',
            'source': 'V',
            'target': 'E',
            'start': 1486479600000,
            'complete': 1487602800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-095900',
            'eventId': '9',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1486479600000,
            'complete': 1490540400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-095600',
            'eventId': '8',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1486652400000,
            'complete': 1486911600000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-105100',
            'eventId': '8',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1486911600000,
            'complete': 1494514800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-101800',
            'eventId': '10',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1486911600000,
            'complete': 1487170800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-103900',
            'eventId': '10',
            'eventName': 'V|E',
            'source': 'V',
            'target': 'E',
            'start': 1486911600000,
            'complete': 1487602800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-102500',
            'eventId': '9',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1486998000000,
            'complete': 1487170800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-105800',
            'eventId': '11',
            'eventName': 'D|J',
            'source': 'D',
            'target': 'J',
            'start': 1486998000000,
            'complete': 1500994800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-105200',
            'eventId': '8',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1487084400000,
            'complete': 1489590000000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-099400',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1487084400000,
            'complete': 1487257200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-101800',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1487170800000,
            'complete': 1492700400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-102500',
            'eventId': '9',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1487170800000,
            'complete': 1487257200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-096000',
            'eventId': '11',
            'eventName': 'D|J',
            'source': 'D',
            'target': 'J',
            'start': 1487257200000,
            'complete': 1504710000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-102500',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1487257200000,
            'complete': 1494169200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-099400',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1487257200000,
            'complete': 1500303600000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-103400',
            'eventId': '9',
            'eventName': 'H|V',
            'source': 'H',
            'target': 'V',
            'start': 1487257200000,
            'complete': 1489330800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-079800',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1487257200000,
            'complete': 1487862000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-083300',
            'eventId': '10',
            'eventName': 'J|E',
            'source': 'J',
            'target': 'E',
            'start': 1487602800000,
            'complete': 1500390000000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-082600',
            'eventId': '10',
            'eventName': 'J|E',
            'source': 'J',
            'target': 'E',
            'start': 1487602800000,
            'complete': 1500390000000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-094800',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1487602800000,
            'complete': 1488207600000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-103900',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1487602800000,
            'complete': 1491836400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-098700',
            'eventId': '11',
            'eventName': 'S|D',
            'source': 'S',
            'target': 'D',
            'start': 1487775600000,
            'complete': 1490799600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-094200',
            'eventId': '8',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1487775600000,
            'complete': 1488380400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-079800',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1487862000000,
            'complete': 1492700400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-099000',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1488121200000,
            'complete': 1488207600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-096100',
            'eventId': '11',
            'eventName': 'D|J',
            'source': 'D',
            'target': 'J',
            'start': 1488121200000,
            'complete': 1500390000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-095200',
            'eventId': '10',
            'eventName': 'S|D',
            'source': 'S',
            'target': 'D',
            'start': 1488121200000,
            'complete': 1494169200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-105400',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1488121200000,
            'complete': 1489590000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-102400',
            'eventId': '11',
            'eventName': 'D|J',
            'source': 'D',
            'target': 'J',
            'start': 1488121200000,
            'complete': 1503241200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-097000',
            'eventId': '8',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1488121200000,
            'complete': 1488898800000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-099000',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1488207600000,
            'complete': 1491836400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-102700',
            'eventId': '8',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1488466800000,
            'complete': 1488812400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-098900',
            'eventId': '9',
            'eventName': 'H|V',
            'source': 'H',
            'target': 'V',
            'start': 1488466800000,
            'complete': 1493218800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-101100',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1488812400000,
            'complete': 1492009200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-102700',
            'eventId': '8',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1488812400000,
            'complete': 1491231600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-094700',
            'eventId': '10',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1488812400000,
            'complete': 1497538800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-089700',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1488898800000,
            'complete': 1496329200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-099200',
            'eventId': '10',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1488985200000,
            'complete': 1489590000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-072300',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1488985200000,
            'complete': 1490194800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-103400',
            'eventId': '9',
            'eventName': 'V|E',
            'source': 'V',
            'target': 'E',
            'start': 1489330800000,
            'complete': 1490281200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-092000',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1489330800000,
            'complete': 1497798000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-088900',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1489330800000,
            'complete': 1492700400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-087400',
            'eventId': '8',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1489417200000,
            'complete': 1490540400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-105400',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1489590000000,
            'complete': 1492700400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-099200',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1489590000000,
            'complete': 1492700400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-096400',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1489676400000,
            'complete': 1492095600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-072300',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1490194800000,
            'complete': 1492700400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-103400',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1490281200000,
            'complete': 1503500400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-098800',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1490281200000,
            'complete': 1495378800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-092500',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1490540400000,
            'complete': 1495378800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-095900',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1490540400000,
            'complete': 1494860400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-104500',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1490540400000,
            'complete': 1494860400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-097100',
            'eventId': '9',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1490540400000,
            'complete': 1494514800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100300',
            'eventId': '10',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1490713200000,
            'complete': 1491231600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-098700',
            'eventId': '11',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1490799600000,
            'complete': 1491836400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-102700',
            'eventId': '8',
            'eventName': 'H|V',
            'source': 'H',
            'target': 'V',
            'start': 1491231600000,
            'complete': 1495724400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-100300',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1491231600000,
            'complete': 1494860400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-059900',
            'eventId': '11',
            'eventName': 'D|D',
            'source': 'D',
            'target': 'D',
            'start': 1491318000000,
            'complete': 1493650800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-091900',
            'eventId': '8',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1491318000000,
            'complete': 1492441200000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-098400',
            'eventId': '8',
            'eventName': 'V|E',
            'source': 'V',
            'target': 'E',
            'start': 1491404400000,
            'complete': 1496761200000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-099100',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1491750000000,
            'complete': 1492095600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100900',
            'eventId': '11',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1491750000000,
            'complete': 1491836400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100900',
            'eventId': '11',
            'eventName': 'J|WW',
            'source': 'J',
            'target': 'WW',
            'start': 1491836400000,
            'complete': 1492354800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-092300',
            'eventId': '10',
            'eventName': 'J|E',
            'source': 'J',
            'target': 'E',
            'start': 1491836400000,
            'complete': 1492614000000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-100600',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1491836400000,
            'complete': 1495119600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-098700',
            'eventId': '11',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1491836400000,
            'complete': 1494860400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-103900',
            'eventId': '10',
            'eventName': 'J|E',
            'source': 'J',
            'target': 'E',
            'start': 1491836400000,
            'complete': 1492009200000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-101500',
            'eventId': '10',
            'eventName': 'J|E',
            'source': 'J',
            'target': 'E',
            'start': 1491836400000,
            'complete': 1492009200000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-104600',
            'eventId': '10',
            'eventName': 'J|E',
            'source': 'J',
            'target': 'E',
            'start': 1491836400000,
            'complete': 1492009200000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-099700',
            'eventId': '12',
            'eventName': 'WW|B',
            'source': 'WW',
            'target': 'B',
            'start': 1491922800000,
            'complete': 1492441200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-101100',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1492009200000,
            'complete': 1492441200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-096400',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1492095600000,
            'complete': 1500303600000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-105300',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1492095600000,
            'complete': 1508425200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-099100',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1492095600000,
            'complete': 1494860400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-101400',
            'eventId': '11',
            'eventName': 'YY|J',
            'source': 'YY',
            'target': 'J',
            'start': 1492268400000,
            'complete': 1506265200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100900',
            'eventId': '11',
            'eventName': 'WW|U',
            'source': 'WW',
            'target': 'U',
            'start': 1492354800000,
            'complete': 1493650800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-101100',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1492441200000,
            'complete': 1500303600000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-106000',
            'eventId': '13',
            'eventName': 'M|WW',
            'source': 'M',
            'target': 'WW',
            'start': 1492441200000,
            'complete': 1492614000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-099700',
            'eventId': '12',
            'eventName': 'B|M',
            'source': 'B',
            'target': 'M',
            'start': 1492441200000,
            'complete': 1492527600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-099700',
            'eventId': '12',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1492527600000,
            'complete': 1492700400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-096100',
            'eventId': '11',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1492527600000,
            'complete': 1492614000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-096000',
            'eventId': '11',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1492527600000,
            'complete': 1492614000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-096100',
            'eventId': '11',
            'eventName': 'J|U',
            'source': 'J',
            'target': 'U',
            'start': 1492614000000,
            'complete': 1492700400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-096000',
            'eventId': '11',
            'eventName': 'J|U',
            'source': 'J',
            'target': 'U',
            'start': 1492614000000,
            'complete': 1492700400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-106000',
            'eventId': '13',
            'eventName': 'J|B',
            'source': 'J',
            'target': 'B',
            'start': 1492614000000,
            'complete': 1495033200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-059900',
            'eventId': '11',
            'eventName': 'M|U',
            'source': 'M',
            'target': 'U',
            'start': 1492614000000,
            'complete': 1492700400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-059900',
            'eventId': '11',
            'eventName': 'U|B',
            'source': 'U',
            'target': 'B',
            'start': 1492700400000,
            'complete': 1492786800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-101800',
            'eventId': '10',
            'eventName': 'J|E',
            'source': 'J',
            'target': 'E',
            'start': 1492700400000,
            'complete': 1500390000000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-096100',
            'eventId': '11',
            'eventName': 'U|B',
            'source': 'U',
            'target': 'B',
            'start': 1492700400000,
            'complete': 1492786800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-096000',
            'eventId': '11',
            'eventName': 'U|M',
            'source': 'U',
            'target': 'M',
            'start': 1492700400000,
            'complete': 1493132400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-099700',
            'eventId': '12',
            'eventName': 'J|U',
            'source': 'J',
            'target': 'U',
            'start': 1492700400000,
            'complete': 1494946800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-102400',
            'eventId': '11',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1492786800000,
            'complete': 1493046000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-059900',
            'eventId': '11',
            'eventName': 'B|WW',
            'source': 'B',
            'target': 'WW',
            'start': 1492786800000,
            'complete': 1492959600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-096100',
            'eventId': '11',
            'eventName': 'B|M',
            'source': 'B',
            'target': 'M',
            'start': 1492786800000,
            'complete': 1492873200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-105800',
            'eventId': '11',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1492873200000,
            'complete': 1493046000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-096100',
            'eventId': '11',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1492873200000,
            'complete': 1494946800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-059900',
            'eventId': '11',
            'eventName': 'H|E',
            'source': 'H',
            'target': 'E',
            'start': 1492959600000,
            'complete': 1493650800000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-102400',
            'eventId': '11',
            'eventName': 'J|U',
            'source': 'J',
            'target': 'U',
            'start': 1493046000000,
            'complete': 1493305200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-105800',
            'eventId': '11',
            'eventName': 'J|M',
            'source': 'J',
            'target': 'M',
            'start': 1493046000000,
            'complete': 1493305200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-096000',
            'eventId': '11',
            'eventName': 'M|B',
            'source': 'M',
            'target': 'B',
            'start': 1493132400000,
            'complete': 1495724400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-098900',
            'eventId': '9',
            'eventName': 'V|E',
            'source': 'V',
            'target': 'E',
            'start': 1493218800000,
            'complete': 1495119600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-102400',
            'eventId': '11',
            'eventName': 'U|B',
            'source': 'U',
            'target': 'B',
            'start': 1493305200000,
            'complete': 1494860400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-080901',
            'eventId': '10',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1493305200000,
            'complete': 1495378800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-105800',
            'eventId': '11',
            'eventName': 'M|U',
            'source': 'M',
            'target': 'U',
            'start': 1493305200000,
            'complete': 1494514800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-059900',
            'eventId': '11',
            'eventName': 'D|A',
            'source': 'D',
            'target': 'A',
            'start': 1493650800000,
            'complete': 1492614000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100900',
            'eventId': '11',
            'eventName': 'U|B',
            'source': 'U',
            'target': 'B',
            'start': 1493650800000,
            'complete': 1495983600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-082700',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1493650800000,
            'complete': 1494860400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-095800',
            'eventId': '8',
            'eventName': 'D|WW',
            'source': 'D',
            'target': 'WW',
            'start': 1493910000000,
            'complete': 1495378800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-102500',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1494169200000,
            'complete': 1495465200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-095200',
            'eventId': '10',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1494169200000,
            'complete': 1496329200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-094000',
            'eventId': '10',
            'eventName': 'YY|E',
            'source': 'YY',
            'target': 'E',
            'start': 1494342000000,
            'complete': 1494514800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-101400',
            'eventId': '11',
            'eventName': 'U|WW',
            'source': 'U',
            'target': 'WW',
            'start': 1494342000000,
            'complete': 1494514800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-097100',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1494514800000,
            'complete': 1495465200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-105800',
            'eventId': '11',
            'eventName': 'U|B',
            'source': 'U',
            'target': 'B',
            'start': 1494514800000,
            'complete': 1495983600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-097800',
            'eventId': '8',
            'eventName': 'YY|E',
            'source': 'YY',
            'target': 'E',
            'start': 1494514800000,
            'complete': 1496329200000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-102600',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1494514800000,
            'complete': 1494946800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-094000',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1494514800000,
            'complete': 1494860400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-105100',
            'eventId': '8',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1494514800000,
            'complete': 1494946800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-101400',
            'eventId': '11',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1494514800000,
            'complete': 1494774000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-096500',
            'eventId': '9',
            'eventName': 'V|E',
            'source': 'V',
            'target': 'E',
            'start': 1494601200000,
            'complete': 1494946800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-101400',
            'eventId': '11',
            'eventName': 'J|M',
            'source': 'J',
            'target': 'M',
            'start': 1494774000000,
            'complete': 1495551600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100400',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1494774000000,
            'complete': 1494860400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-102400',
            'eventId': '11',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1494860400000,
            'complete': 1496761200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077600',
            'eventId': '10',
            'eventName': 'S|E',
            'source': 'S',
            'target': 'E',
            'start': 1494860400000,
            'complete': 1497884400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100400',
            'eventId': '10',
            'eventName': 'J|E',
            'source': 'J',
            'target': 'E',
            'start': 1494860400000,
            'complete': 1500390000000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-104500',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1494860400000,
            'complete': 1495033200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-095900',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1494860400000,
            'complete': 1494946800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-096500',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1494946800000,
            'complete': 1500390000000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-076201',
            'eventId': '12',
            'eventName': 'M|U',
            'source': 'M',
            'target': 'U',
            'start': 1494946800000,
            'complete': 1495033200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-099700',
            'eventId': '12',
            'eventName': 'H|S',
            'source': 'H',
            'target': 'S',
            'start': 1494946800000,
            'complete': 1495119600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-105100',
            'eventId': '8',
            'eventName': 'J|U',
            'source': 'J',
            'target': 'U',
            'start': 1494946800000,
            'complete': 1495033200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-095900',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1494946800000,
            'complete': 1500390000000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-102600',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1494946800000,
            'complete': 1500303600000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-096100',
            'eventId': '11',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1494946800000,
            'complete': 1495119600000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-104500',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1495033200000,
            'complete': 1500303600000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-076201',
            'eventId': '12',
            'eventName': 'U|J',
            'source': 'U',
            'target': 'J',
            'start': 1495033200000,
            'complete': 1495465200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-096900',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1495033200000,
            'complete': 1495465200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-105100',
            'eventId': '8',
            'eventName': 'U|B',
            'source': 'U',
            'target': 'B',
            'start': 1495033200000,
            'complete': 1496156400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-106000',
            'eventId': '13',
            'eventName': 'B|U',
            'source': 'B',
            'target': 'U',
            'start': 1495033200000,
            'complete': 1495724400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-097900',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1495119600000,
            'complete': 1495465200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100600',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1495119600000,
            'complete': 1500303600000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-099700',
            'eventId': '12',
            'eventName': 'S|D',
            'source': 'S',
            'target': 'D',
            'start': 1495119600000,
            'complete': 1495551600000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-098900',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1495119600000,
            'complete': 1500390000000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-095800',
            'eventId': '8',
            'eventName': 'WW|U',
            'source': 'WW',
            'target': 'U',
            'start': 1495378800000,
            'complete': 1495465200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-092500',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1495378800000,
            'complete': 1495724400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-080901',
            'eventId': '10',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1495378800000,
            'complete': 1495551600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-098800',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1495378800000,
            'complete': 1495983600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-097900',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1495465200000,
            'complete': 1500390000000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-076201',
            'eventId': '12',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1495465200000,
            'complete': 1495983600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-105600',
            'eventId': '8',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1495465200000,
            'complete': 1501686000000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-097100',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1495465200000,
            'complete': 1500390000000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-095800',
            'eventId': '8',
            'eventName': 'U|M',
            'source': 'U',
            'target': 'M',
            'start': 1495465200000,
            'complete': 1495638000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-102500',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1495465200000,
            'complete': 1500303600000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-096900',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1495465200000,
            'complete': 1500390000000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-080901',
            'eventId': '10',
            'eventName': 'J|U',
            'source': 'J',
            'target': 'U',
            'start': 1495551600000,
            'complete': 1495638000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-101400',
            'eventId': '11',
            'eventName': 'M|B',
            'source': 'M',
            'target': 'B',
            'start': 1495551600000,
            'complete': 1497193200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-080901',
            'eventId': '10',
            'eventName': 'U|M',
            'source': 'U',
            'target': 'M',
            'start': 1495638000000,
            'complete': 1495983600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-095800',
            'eventId': '8',
            'eventName': 'M|J',
            'source': 'M',
            'target': 'J',
            'start': 1495638000000,
            'complete': 1495724400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-099700',
            'eventId': '12',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1495638000000,
            'complete': 1500908400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-096000',
            'eventId': '11',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1495724400000,
            'complete': 1498402800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-095800',
            'eventId': '8',
            'eventName': 'J|B',
            'source': 'J',
            'target': 'B',
            'start': 1495724400000,
            'complete': 1500476400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-106000',
            'eventId': '13',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1495724400000,
            'complete': 1496156400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-092500',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1495724400000,
            'complete': 1503500400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-096800',
            'eventId': '11',
            'eventName': 'D|J',
            'source': 'D',
            'target': 'J',
            'start': 1495897200000,
            'complete': 1504710000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-080901',
            'eventId': '10',
            'eventName': 'M|B',
            'source': 'M',
            'target': 'B',
            'start': 1495983600000,
            'complete': 1496415600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100900',
            'eventId': '11',
            'eventName': 'H|V',
            'source': 'H',
            'target': 'V',
            'start': 1495983600000,
            'complete': 1497279600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-105800',
            'eventId': '11',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1495983600000,
            'complete': 1496156400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-076201',
            'eventId': '12',
            'eventName': 'D|지속가능경영팀 (complete)',
            'source': 'D',
            'target': '지속가능경영팀 (complete)',
            'start': 1495983600000,
            'complete': 1496847600000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-099500',
            'eventId': '9',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1495983600000,
            'complete': 1497798000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-098800',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1495983600000,
            'complete': 1500303600000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-096600',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1496070000000,
            'complete': 1500908400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-096800',
            'eventId': '11',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1496070000000,
            'complete': 1496242800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-106000',
            'eventId': '13',
            'eventName': 'D|지속가능경영팀 (complete)',
            'source': 'D',
            'target': '지속가능경영팀 (complete)',
            'start': 1496156400000,
            'complete': 1496847600000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-105800',
            'eventId': '11',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1496156400000,
            'complete': 1497193200000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-096800',
            'eventId': '11',
            'eventName': 'M|U',
            'source': 'M',
            'target': 'U',
            'start': 1496242800000,
            'complete': 1496761200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-089700',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1496329200000,
            'complete': 1500303600000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-095200',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1496329200000,
            'complete': 1500994800000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-080901',
            'eventId': '10',
            'eventName': 'H|S',
            'source': 'H',
            'target': 'S',
            'start': 1496415600000,
            'complete': 1496934000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-102400',
            'eventId': '11',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1496761200000,
            'complete': 1500994800000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-096800',
            'eventId': '11',
            'eventName': 'U|B',
            'source': 'U',
            'target': 'B',
            'start': 1496761200000,
            'complete': 1497884400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-101400',
            'eventId': '11',
            'eventName': 'H|YY',
            'source': 'H',
            'target': 'YY',
            'start': 1497193200000,
            'complete': 1501772400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-100900',
            'eventId': '11',
            'eventName': 'V|E',
            'source': 'V',
            'target': 'E',
            'start': 1497279600000,
            'complete': 1505314800000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-098700',
            'eventId': '11',
            'eventName': 'E|M',
            'source': 'E',
            'target': 'M',
            'start': 1497452400000,
            'complete': 1481036400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-094700',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1497538800000,
            'complete': 1508252400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-092000',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1497798000000,
            'complete': 1500994800000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-099500',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1497798000000,
            'complete': 1503500400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-077600',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1497884400000,
            'complete': 1503500400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-096800',
            'eventId': '11',
            'eventName': 'B|J',
            'source': 'B',
            'target': 'J',
            'start': 1497884400000,
            'complete': 1497970800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-096800',
            'eventId': '11',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1497970800000,
            'complete': 1498057200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-096800',
            'eventId': '11',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1498057200000,
            'complete': 1499612400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-096000',
            'eventId': '11',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1498402800000,
            'complete': 1499785200000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-101900',
            'eventId': '8',
            'eventName': 'J|WW',
            'source': 'J',
            'target': 'WW',
            'start': 1499353200000,
            'complete': 1499439600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-101900',
            'eventId': '8',
            'eventName': 'WW|M',
            'source': 'WW',
            'target': 'M',
            'start': 1499439600000,
            'complete': 1499612400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-101900',
            'eventId': '8',
            'eventName': 'M|U',
            'source': 'M',
            'target': 'U',
            'start': 1499612400000,
            'complete': 1500908400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-106000',
            'eventId': '13',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1500217200000,
            'complete': 1507734000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-076201',
            'eventId': '12',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1500217200000,
            'complete': 1507734000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-096100',
            'eventId': '11',
            'eventName': 'J|WW',
            'source': 'J',
            'target': 'WW',
            'start': 1500390000000,
            'complete': 1492527600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-097600',
            'eventId': '8',
            'eventName': 'M|U',
            'source': 'M',
            'target': 'U',
            'start': 1500476400000,
            'complete': 1500994800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-080600',
            'eventId': '11',
            'eventName': 'E|WW',
            'source': 'E',
            'target': 'WW',
            'start': 1500476400000,
            'complete': 1456844400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-077500',
            'eventId': '11',
            'eventName': 'E|WW',
            'source': 'E',
            'target': 'WW',
            'start': 1500476400000,
            'complete': 1453906800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-101900',
            'eventId': '8',
            'eventName': 'U|B',
            'source': 'U',
            'target': 'B',
            'start': 1500908400000,
            'complete': 1505919600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-099700',
            'eventId': '12',
            'eventName': 'J|WW',
            'source': 'J',
            'target': 'WW',
            'start': 1500908400000,
            'complete': 1491922800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-105800',
            'eventId': '11',
            'eventName': 'J|WW',
            'source': 'J',
            'target': 'WW',
            'start': 1500994800000,
            'complete': 1492873200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-097600',
            'eventId': '8',
            'eventName': 'U|WW',
            'source': 'U',
            'target': 'WW',
            'start': 1500994800000,
            'complete': 1501081200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-097600',
            'eventId': '8',
            'eventName': 'WW|B',
            'source': 'WW',
            'target': 'B',
            'start': 1501081200000,
            'complete': 1502290800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-093701',
            'eventId': '11',
            'eventName': 'WW|J',
            'source': 'WW',
            'target': 'J',
            'start': 1501513200000,
            'complete': 1501599600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-096200',
            'eventId': '10',
            'eventName': 'WW|U',
            'source': 'WW',
            'target': 'U',
            'start': 1501513200000,
            'complete': 1501686000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-093701',
            'eventId': '11',
            'eventName': 'M|U',
            'source': 'M',
            'target': 'U',
            'start': 1501599600000,
            'complete': 1501772400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-096200',
            'eventId': '10',
            'eventName': 'U|J',
            'source': 'U',
            'target': 'J',
            'start': 1501686000000,
            'complete': 1502031600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-093701',
            'eventId': '11',
            'eventName': 'U|B',
            'source': 'U',
            'target': 'B',
            'start': 1501772400000,
            'complete': 1502290800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-101400',
            'eventId': '11',
            'eventName': 'YY|E',
            'source': 'YY',
            'target': 'E',
            'start': 1501772400000,
            'complete': 1502377200000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-096200',
            'eventId': '10',
            'eventName': 'M|B',
            'source': 'M',
            'target': 'B',
            'start': 1502031600000,
            'complete': 1502982000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-093701',
            'eventId': '11',
            'eventName': 'H|V',
            'source': 'H',
            'target': 'V',
            'start': 1502290800000,
            'complete': 1503846000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-097200',
            'eventId': '8',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1502290800000,
            'complete': 1508684400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-096200',
            'eventId': '10',
            'eventName': 'H|D',
            'source': 'H',
            'target': 'D',
            'start': 1502982000000,
            'complete': 1504796400000,
            'eventState': ''
        },
        {
            'caseId': 'I16-102400',
            'eventId': '11',
            'eventName': 'J|WW',
            'source': 'J',
            'target': 'WW',
            'start': 1503241200000,
            'complete': 1492786800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-093701',
            'eventId': '11',
            'eventName': 'V|E',
            'source': 'V',
            'target': 'E',
            'start': 1503846000000,
            'complete': 1505142000000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-096800',
            'eventId': '11',
            'eventName': 'J|WW',
            'source': 'J',
            'target': 'WW',
            'start': 1504710000000,
            'complete': 1496070000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-096000',
            'eventId': '11',
            'eventName': 'J|WW',
            'source': 'J',
            'target': 'WW',
            'start': 1504710000000,
            'complete': 1492527600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-096200',
            'eventId': '10',
            'eventName': 'D|E',
            'source': 'D',
            'target': 'E',
            'start': 1504796400000,
            'complete': 1506610800000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-101400',
            'eventId': '11',
            'eventName': 'J|U',
            'source': 'J',
            'target': 'U',
            'start': 1506265200000,
            'complete': 1494342000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-093701',
            'eventId': '11',
            'eventName': 'J|WW',
            'source': 'J',
            'target': 'WW',
            'start': 1506265200000,
            'complete': 1501513200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-076201',
            'eventId': '12',
            'eventName': 'E|WW',
            'source': 'E',
            'target': 'WW',
            'start': 1507734000000,
            'complete': 1494946800000,
            'eventState': ''
        },
        {
            'caseId': 'I16-106000',
            'eventId': '13',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1507734000000,
            'complete': 1508079600000,
            'eventState': ''
        },
        {
            'caseId': 'I16-079300',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1507734000000,
            'complete': 1508079600000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-085600',
            'eventId': '10',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1507734000000,
            'complete': 1508079600000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-100900',
            'eventId': '11',
            'eventName': 'J|M',
            'source': 'J',
            'target': 'M',
            'start': 1507734000000,
            'complete': 1491750000000,
            'eventState': ''
        },
        {
            'caseId': 'I16-106000',
            'eventId': '13',
            'eventName': 'J|M',
            'source': 'J',
            'target': 'M',
            'start': 1508079600000,
            'complete': 1492441200000,
            'eventState': ''
        },
        {
            'caseId': 'I16-095500',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1508079600000,
            'complete': 1508425200000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-094700',
            'eventId': '10',
            'eventName': 'J|E',
            'source': 'J',
            'target': 'E',
            'start': 1508252400000,
            'complete': 1508684400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-105300',
            'eventId': '9',
            'eventName': 'E|J',
            'source': 'E',
            'target': 'J',
            'start': 1508425200000,
            'complete': 1508684400000,
            'eventState': 'last'
        },
        {
            'caseId': 'I16-097700',
            'eventId': '4',
            'eventName': 'WW|U',
            'source': 'WW',
            'target': 'U',
            'start': 1508684400000,
            'complete': 1508857200000,
            'eventState': 'last'
        }
    ]
};
